import React from 'react'
import { SourcingDetailBuyerFormStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  DatePickerInput,
  InputUpload,
  InputUploadExcel,
  Section,
  SelectBox,
  Input,
  Checkbox,
  InputTextarea,
  Table,
  Spinner,
  Text,
  Toggle,
  Loaders,
  Breadcrumbs,
  SelectBoxPredecessor,
  SelectBoxPurchasingSite,
  Paginate,
  AttachedFile,
  Loading,
} from '../../components'
import {
  rfqController,
  auctionController,
  eventNewController,
  purchasingSiteController,
} from '../../apiService'
import { ICONS } from '../../themes'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  ROUTE_PATH,
  STRING,
  toastFail,
  toastActive,
  localStorageService,
  Option,
  ValueContainer,
  MultiValue,
  AnimatedComponents,
  pageData,
  isAllowedChangePage,
} from '../../helpers'
import { pageSourcingBuyerDetailFormController } from '../../middleware'
import FileDownload from 'js-file-download'
import Numeral from 'numeral'
import NumberFormat from 'react-number-format'
import { toast } from 'react-toastify'
import { map, filter } from 'lodash'
import moment from 'moment'
import Moment from 'moment'
import { companyController } from '../../apiService/index'
import { checkFileType } from '../../helpers/functions/checkFileType'
import AuctionEnglish from './auctionType/AuctionEnglish'
import AuctionSealed from './auctionType/AuctionSealed'
import { createBrowserHistory } from 'history'

const currencyIdFunc = () => {
  const url = window.location.hostname
  switch (url) {
    case 'buyer.dev.astrosystem.co':
      return 2
    case 'supplier.dev.astrosystem.co':
      return 2
    case 'buyer.astrosystem.co':
      return 2
    case 'supplier.astrosystem.co':
      return 2
    case 'buyer.tspacesourcing.com':
      return 2
    case 'supplier.tspacesourcing.com':
      return 2
    case 'buyer.uat.astrosystem.co':
      return 2
    case 'supplier.uat.astrosystem.co':
      return 2
    default:
      return 2
  }
}

let filterListTable3 = []
class SourcingDetailBuyerForm extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)
    this.state = {
      selectedEventType: '',
      isFromDetail: false,
      id: '',
      isEdit: false,
      isLoader: false,
      isLoading: false,
      uploadFail: false,
      eventVat: 'Exclude VAT',
      startDate: undefined,
      endDate: undefined,
      businessCategory: [],
      currency: [],
      purchasingCompany: [],
      purchasingTypes: [],
      UOM: [],
      activeStep: 0,
      modals: [
        { name: 'add-supplier', isOpen: false },
        { name: 'confirm-submit', isOpen: false },
        { name: 'confirm-switch-event', isOpen: false },
      ],
      formData: {
        isCopyOrNewRound: false,
        id: '',
        rfq_status_id: 1,
        sourcing_project_attachment_files_request: [],
        step1: {
          sourcingProject: {
            name: '',
            project_status_id: 1,
            project_no: '',
            createDate: '',
            project_status_name: '',
            description: '',
            cancel_reason: '',
            internal_note: '',
            target_date: '',
            estimate_budget: '',
            target_saving: 0,
            project_reference: '',
            predecessors: '',
            categories: '',
            purchasing_companies: '',
            purchasing_company_web: '',
            create_by: '',
          },
        },
        step2: {
          eventInformation: {
            idRfq: '',
            eventType: 0,
            eventName: '',
            is_BidType: 1,
            is_vat: false,
            currency_id: currencyIdFunc(),
            purchasingType: 1,
            seal_type: false,
            auction_award_status_id: 1,
            auction_status_id: 1,
            auctionType: 1,
            idAuction: '',
            eventOpeningPrice: '',
            eventReservePrice: '',
            is_ExtensionTime: false,
            eventExtensionMinutes: '',
            bidSubmission: 1,
            is_MaxExtension: true,
            eventExtensionTime: '',
            is_display_dummy: false,
            eventHideLeadingBidTime: '',
            isDisable_checkbox: false,
            description: '',
            is_HideLeadingBidAmount: false,
            is_HideLeadingBidTime: false,
            internal_note: '',
            internalFile: [],
            seal_status: 0,
            is_bid: false,
            bid_decrement: '',
            bid_minimum: '',
          },
        },
      },
      products: {
        items: [],
      },
      formProduct: {
        budget_price: null,
        description: '',
        historical_price: null,
        market_price: null,
        name: '',
        req_amount: null,
        uom_id: null,
        rfq_buyer_item_file: [],
        auction_buyer_item_file: [],
        buyer_item_file: [],
      },
      isEditProduct: false,
      indexProductEdit: null,
      isErrName: false,
      isErrCategory: false,
      isErrEventType: false,
      isErrEventName: false,
      isErrPurchasingType: false,
      isErrBiddingType: false,
      isErrProjectReference: false,
      isErrCompanyCode: false,
      isErrCurrency: false,
      irErrVat: false,
      isErrExtensionTime: false,
      isErrExtensionMinutes: false,
      isErrMaxExtensionTime: false,
      isErrAuctionType: false,
      isErrOpeningPrice: false,
      isErrBid: false,
      isErrReservePrice: false,
      isErrHideLeadingBidTime: false,
      isErrHideLeadingBidAmount: false,
      isErrDisplayDummy: false,
      isErrEstimateBudget: false,
      isErrTargetSaving: false,
      isErrTargetDate: false,
      isErrProductName: false,
      isErrProductDescription: false,
      isErrProductQty: false,
      isErrProductBuget: false,
      isErrProductUOM: false,
      isErrStartDate: false,
      isErrEndDate: false,
      isErrMsgStartDate: '',
      isErrMsgEndDate: '',
      isErrMsgTargetDate: '',
      isErrMsgEstimateBudget: '',
      suppliersRfq: [],
      selectSuppliersRfq: [],
      stackSelectSuppliersRfq: [],
      searchKeywords: '',
      stateSupplierRqfLoading: false,
      internalFile: [],
      externalFile: [],
      isSubmit: false,
      paginationSupplierlist: {
        page: 0,
        next_page: 1,
      },
      clicks: 0,
      optionSelected: '',
      loadingFileInternal: false,
      loadingFileStep2: false,
      loadingFileStep3: false,
      loadingDownloadFile: [],
      optionsPredecessor: [],
      valuePredecessor: '',
      optionsEventType: '',
      optionsBiddingType: [
        {
          value: 1,
          label: 'Reverse',
        },
        {
          value: 2,
          label: 'Forward',
        },
      ],
      optionsAuctionType: '',
      getCreatenewround: '',
      editRoleDetail: null,
      baseCurrency: 'THB',
      baseCurrencyId: '',
      isUpload: false,
      auction_time: 0,

      searchPage: 1,
      activePage: 1,
      limit: 1000,
      total_record: 0,
      total_page: 1,
      offset_page: 0,
    }
  }
  onChangeBudget = e => {
    //replace non-digits with blank
    return e ? Number(e) : e
  }

  componentDidMount() {
    // console.log('ma', this.props.match.params)
    const isFromDetail = localStorage.getItem('isFromDetail')
      ? localStorage.getItem('isFromDetail')
      : false
    this._isMounted = true
    let { getCreatenewround } = this.state
    const { match } = this.props
    const { createnewround, idproject, eventid, id } = match.params
    getCreatenewround = idproject && !eventid ? true : false
    this.setState({
      isFromDetail,
      getCreatenewround,
    })
    document
      .getElementById('sourcing-add-supplier')
      .addEventListener('scroll', this._handleScroll.bind(this))
    let copyid = this.props.location.state
    this.getMaster.getBusinessCategory()
    this.getMaster.getCurrency()
    const funcGetPurchasingCompany = async () => {
      await this.getMaster.getPurchasingCompany()
    }
    funcGetPurchasingCompany()
    this.getMaster.getPurchasingTypes()
    this.getMaster.getSupplierRqf('', 1, true)
    this.getMaster.getUOM()
    if (copyid) {
      this.copyRFQById(copyid)
    }
    this.funcGetPredecessor()
    this.funcGetSourcIngProjectRfq()
    this.funcGetEventType()
    this.funcGetAuctionType()
    this.funcCheckRoles()
    this.funcCheckCopy()
    this.getCompany()
  }

  getCompany = async () => {
    try {
      const res = await companyController().getCompany()
      if (res) {
        this.setState({
          baseCurrency: res.base_currency.name,
          baseCurrencyId: res.base_currency.id,
          auction_time: res.auction_time,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  funcCheckCopy() {
    const idRfqCopy = localStorage.getItem('copy_event_eventid')
    const { match } = this.props
    const { idproject, eventid } = match.params
    const { formData } = this.state
    const localRfqCr = !eventid ? idRfqCopy : eventid
    const queryParams = new URLSearchParams(window.location.search)
    if ((idproject && eventid) || (idproject && !eventid)) {
      const params = {
        sourcing_project_id: idproject,
        // sourcing_id: eventid ? eventid : '',
        event_id: eventid ? eventid : '',
      }
      this.setState({ isLoader: true })
      // rfqController()
      // .getTempSourcingProject(params)
      eventNewController()
        .getTempSourcingProject(params)
        .then(async res => {
          if (res) {
            const {
              rfq,
              event,
              event_items,
              rfq_items,
              // sourcing_project_request,
              sourcing_project,
              auction_items,
              auction,
              suppliers,
            } = res
            this.funcCheckRoles(
              sourcing_project.created_by,
              sourcing_project.created_by_id
            )
            const { step1 } = formData
            const { sourcingProject } = step1
            const resultFiles = await this.funcGetInternalFileProject(idproject)
            sourcingProject.project_no = sourcing_project.project_no
            sourcingProject.project_status_id =
              sourcing_project.project_status_id === 0
                ? 1
                : sourcing_project.project_status_id
            const projectStatusName = this.funcCheckProjectStatus(
              sourcing_project.project_status_id
            )
            sourcingProject.project_status_name = projectStatusName
            formData.id = ''
            if (idproject && !eventid) {
              formData.id = idproject
            } else if (idproject && eventid) {
              formData.id = ''
            }
            const createdAt =
              sourcing_project.created_at &&
              moment(sourcing_project.created_at).format('MMM DD, YYYY hh:mm A')
            const setTimeTargetDate = sourcing_project.target_date
              ? moment(
                  sourcing_project.target_date,
                  'YYYY/MM/DD HH:mm:ss'
                ).toDate()
              : null
            const targetDate = setTimeTargetDate
            formData.isCopyOrNewRound = true
            sourcingProject.createDate = createdAt
            sourcingProject.name = sourcing_project.name
            sourcingProject.created_by = sourcing_project.created_by
            sourcingProject.description = sourcing_project.description
            sourcingProject.estimate_budget = sourcing_project.estimate_budget
            sourcingProject.target_saving = sourcing_project.target_saving
            const arrCategories = [sourcing_project.category]
            const valueCategories = this.matchValueSelected(arrCategories)
            const valuePredecessor = {
              value: sourcing_project.predecessors
                ? sourcing_project.predecessors.id
                : '',
              label: sourcing_project.predecessors
                ? sourcing_project.predecessors.name
                : '',
            }
            const valuePurchasingCompanies = map(
              sourcing_project.purchasing_companies,
              (v, k) => {
                return {
                  value: v.id,
                  label: v.name,
                }
              }
            )
            const objCategories = {
              value: valueCategories.id,
              label: valueCategories.name,
            }
            sourcingProject.categories = objCategories.value
              ? objCategories
              : ''
            sourcingProject.target_date = targetDate
            sourcingProject.predecessors = valuePredecessor.value
              ? valuePredecessor
              : ''
            sourcingProject.project_reference =
              sourcing_project.project_reference
            sourcingProject.internal_note = sourcing_project.internal_note
            sourcingProject.purchasing_company_web = valuePurchasingCompanies
            const mapArrayFiles = this.funcMapFilesStatusProject(resultFiles)
            formData.sourcing_project_attachment_files_request = mapArrayFiles

            if (event && event.name) {
              const {
                name,
                event_type_id,
                description,
                purchasing_type_id,
                currency_id,
                is_vat,
                internal_note,
                seal_type,
                seal_status,
                start_date,
                end_date,
                note_to_supplier,
                // id: idRfq,
                event_id,
                id,
                bidding_type_id,
              } = event
              const filesRfq = await this.funcGetInternalFileById(id)
              this.getProductById(id)
              const { step2 } = formData
              const { eventInformation } = step2
              const setTimeStartDate = start_date
                ? moment(start_date, 'YYYY/MM/DD HH:mm:ss').toDate()
                : null
              const setTimeEndDate = end_date
                ? moment(end_date, 'YYYY/MM/DD HH:mm:ss').toDate()
                : null
              const defaultTime = '0001-01-01 00:00:00 +0000 UTC'
              formData.start_date =
                start_date === defaultTime ? '' : setTimeStartDate
              formData.end_date = end_date === defaultTime ? '' : setTimeEndDate
              formData.note_to_supplier = note_to_supplier
                ? note_to_supplier
                : ''
              eventInformation.eventName = name
              eventInformation.eventType = event_type_id
              eventInformation.purchasingType = purchasing_type_id
              eventInformation.currency_id = currency_id
                ? currency_id
                : currencyIdFunc()
              eventInformation.description = description
              eventInformation.is_vat = is_vat
              eventInformation.internal_note = internal_note
              eventInformation.seal_status = seal_status
              eventInformation.seal_type = seal_type
              eventInformation.idRfq = ''
              eventInformation.idAuction = ''
              const mapArrayFiles = this.funcMapFilesStatus(filesRfq)
              eventInformation.internalFile = mapArrayFiles
              eventInformation.is_BidType = bidding_type_id
              eventInformation.eventIdForDownload = event_id

              if (event_type_id === 2) {
                eventInformation.eventOpeningPrice = event.opening_price
                eventInformation.is_bid = event.is_min_bid_used
                eventInformation.bid_decrement = event.bid_decrement_increment
                eventInformation.bid_minimum = event.min_bid_decrement_increment
                eventInformation.is_ExtensionTime = event.is_extension_time_used
                eventInformation.eventExtensionMinutes = event.extension_minutes
                eventInformation.is_MaxExtension = event.extension_time
                  ? true
                  : false
                eventInformation.eventExtensionTime = event.extension_time
                eventInformation.is_HideLeadingBidAmount =
                  event.use_hide_leading_bid_reserve
                eventInformation.eventHideLeadingBidTime =
                  event.hide_leading_bid_time_before_close
                eventInformation.is_HideLeadingBidTime = event.hide_leading_bid_time_before_close
                  ? true
                  : false
                eventInformation.is_BidType = event.bidding_type_id
                eventInformation.is_display_dummy =
                  event.display_dummy_supplier_name
              }
            }
            // if (auction && auction.name) {
            //   console.log(auction)
            //   const filesRfq = await this.funcGetInternalFileById(
            //     auction.event_id
            //   )
            //   this.getProductById(auction.event_id)
            //   const { step2 } = formData
            //   const { eventInformation } = step2
            //   const setTimeStartDate = auction.start_date
            //     ? moment(auction.start_date, 'YYYY/MM/DD HH:mm:ss')
            //         .utc(auction.start_date)
            //         .toDate()
            //     : null
            //   const setTimeEndDate = auction.end_date
            //     ? moment(auction.end_date, 'YYYY/MM/DD HH:mm:ss')
            //         .utc(auction.end_date)
            //         .toDate()
            //     : null
            //   const defaultTime = '0001-01-01 00:00:00 +0000 UTC'
            //   formData.start_date = '' // rfq ส่งว่าง
            //   formData.end_date = '' // rfq ส่งว่าง
            //   formData.note_to_supplier = auction.note_to_supplier
            //     ? auction.note_to_supplier
            //     : ''
            //   eventInformation.eventName = auction.name
            //   eventInformation.auctionType = auction.auction_type_id
            //   eventInformation.eventType = auction.event_type_id
            //   eventInformation.purchasingType = auction.purchasing_type_id
            //   eventInformation.currency_id = auction.currency_id
            //   eventInformation.description = auction.description
            //   eventInformation.is_vat = auction.is_vat
            //   eventInformation.internal_note = auction.internal_note
            //   eventInformation.idAuction = auction.id
            //   eventInformation.idRfq = ''
            //   eventInformation.eventOpeningPrice = auction.opening_price
            //   eventInformation.eventReservePrice = auction.reserve_price
            //   eventInformation.is_bid = auction.is_min_bid_used
            //   eventInformation.bid_decrement = auction.bid_decrement_increment
            //   eventInformation.bid_minimum = auction.min_bid_decrement_increment
            //   eventInformation.is_ExtensionTime = auction.is_extension_time_used
            //   eventInformation.eventExtensionMinutes = auction.extension_minutes
            //   eventInformation.is_MaxExtension = auction.extension_time
            //     ? true
            //     : false
            //   eventInformation.eventExtensionTime = auction.extension_time
            //   eventInformation.is_HideLeadingBidAmount =
            //     auction.use_hide_leading_bid_reserve
            //   eventInformation.eventHideLeadingBidTime =
            //     auction.hide_leading_bid_time_before_close
            //   eventInformation.is_HideLeadingBidTime = auction.hide_leading_bid_time_before_close
            //     ? true
            //     : false
            //   eventInformation.is_BidType = auction.bidding_type_id
            //   eventInformation.is_display_dummy =
            //     auction.display_dummy_supplier_name
            //   const mapArrayFiles = this.funcMapFilesStatus(filesRfq)
            //   eventInformation.internalFile = mapArrayFiles
            //   eventInformation.eventIdForDownload = auction.event_id
            // }
            const { products, selectSuppliersRfq } = this.state
            // if (rfq_items && rfq_items.items) {
            //   products.items = rfq_items.items
            // }
            // if (auction_items && auction_items.items) {
            //   products.items = auction_items.items
            // }
            if (event_items) {
              products.items = event_items
            }

            this.setState({
              formData,
              products,
              selectSuppliersRfq,
              isLoader: false,
            })
          }
        })
        .catch(err => {
          throw err
        })
    }
  }
  funcCheckRoles(user = '', id) {
    let { editRoleDetail } = this.state
    // editRoleDetail เช็ค user ว่ามีสิทธ์แก้ไขข้อมูลหรือไม่
    const resUserName = localStorageService.getUsersName()
    const buyerId = localStorage.getItem('buyerId')
    const roles = pageSourcingBuyerDetailFormController().asset(
      resUserName,
      user
    )
    const strId = id ? id.toString() : ''

    // console.log('resUserName', roles, resUserName, user)
    const { edit } = roles
    if (strId) {
      editRoleDetail = edit && buyerId === strId
    } else {
      editRoleDetail = edit
    }
    this.setState({ editRoleDetail })
  }
  funcGetEventType = async () => {
    try {
      const resEventType = await rfqController().getEventTypes()
      // mockup data pending API
      const arrEventType = map(resEventType, (value, index) => {
        const { ID, name } = value
        return {
          value: ID,
          label: name,
        }
      })
      this.setState({ optionsEventType: arrEventType })
    } catch (error) {
      console.log(error)
    }
  }
  funcGetAuctionType = async () => {
    try {
      const resAuctionType = await auctionController().getAuctionType()
      const arrAuctionType = map(resAuctionType, (value, index) => {
        const { id, name } = value
        return {
          value: id,
          label: name,
        }
      })
      // this.setState({ optionsAuctionType: arrAuctionType })
      this.setState({ optionsAuctionType: [{ value: 1, label: 'English' }] })
    } catch (error) {
      console.log(error)
    }
  }
  funcGetPredecessor = async () => {
    try {
      const resPredecessor = await rfqController().getPredecessor()
      const PredecessorNoSelect = {
        value: null,
        label: 'No Select',
      }
      const arrPredecessor = map(resPredecessor, (value, index) => {
        const { id, name, project_no } = value
        return {
          value: id,
          label: `${project_no} ${project_no ? '-' : ''} ${name}`,
        }
      })
      this.setState({
        optionsPredecessor: [PredecessorNoSelect, ...arrPredecessor],
      })
    } catch (error) {
      console.log(error)
    }
  }
  funcGetInternalFileById = async id => {
    // console.log('internalfile by id', id)
    if (id) {
      let res = await eventNewController().getInternalFileById(id)
      return res
    }
  }
  funcGetInternalFileProject = async id => {
    if (id) {
      const res = await rfqController().getInternalFileProject(id)
      return res
    }
  }
  funcMapFilesStatusProject(array) {
    const mapArrayFiles = map(array, (v, k) => {
      const { id, file_name } = v
      return { id, file_name, is_deleted: false }
    })
    return mapArrayFiles
  }
  funcMapFilesStatus(array) {
    const mapArrayFiles = map(array, (v, k) => {
      const { id, name } = v
      return { id, name, is_deleted: false }
    })
    return mapArrayFiles
  }
  funcGetSourcIngProjectRfq = async () => {
    const { formData } = this.state
    const { match } = this.props
    const { id, eventid, idproject } = match.params
    console.log({ id, eventid, idproject })
    const obj = {
      id,
      eventId: eventid ? eventid : '',
    }

    if (id || idproject || eventid) {
      this.setState({ isLoader: true })
    }
    let res
    try {
      // res = await rfqController().getSourcingProject(obj)
      if (id && !idproject && !eventid) {
        // const res = await rfqController().getSourcingProject(obj)
        res = await eventNewController().getProjectBuyer(id)
      } else if (id && eventid) {
        res = await eventNewController().getEventDetailBuyer(eventid)
      }
      if (res) {
        const project =
          res.project_no != null || res.name != null || res.id != null
            ? res
            : res.result && typeof res.result === 'object'
            ? res.result
            : res
        const {
          project_no,
          project_status_id,
          name,
          created_at,
          description,
          estimate_budget,
          target_saving,
          predecessors,
          project_reference,
          internal_note,
          purchasing_companies,
          id,
          target_date,
          created_by,
          created_by_id,
        } = project
        const categories = project.categories || project.category
        const rfqEvent =
          project.events &&
          project.events.find(
            event => event.rfq_detail || event.event_type_id === 1
          )
        const auctionEvent =
          project.events &&
          project.events.find(
            event => event.auction_detail || event.event_type_id === 2
          )
        const rfq_details =
          project.rfq_details || (rfqEvent && (rfqEvent.rfq_detail || rfqEvent))
        const auction_details =
          project.auction_details ||
          (auctionEvent && (auctionEvent.auction_detail || auctionEvent))
        this.funcCheckRoles(created_by, created_by_id)
        const { step1 } = formData
        const { sourcingProject } = step1
        const resultFiles = await this.funcGetInternalFileProject(id) //ใช้ทั้ง RFQ Auction
        sourcingProject.project_no = project_no
        if (project_no) {
          this.setState({
            getCreatenewround: true,
          })
        }
        sourcingProject.project_status_id = project_status_id
        const projectStatusName = this.funcCheckProjectStatus(project_status_id)
        sourcingProject.project_status_name = projectStatusName
        formData.id = id
        const createdAt = created_at
          ? moment(created_at).format('MMM DD, YYYY hh:mm A')
          : ''
        const setTimeTargetDate = target_date
          ? moment(target_date, 'YYYY/MM/DD HH:mm:ss').toDate()
          : null
        const targetDate = setTimeTargetDate
        sourcingProject.createDate = createdAt
        sourcingProject.name = name || ''
        sourcingProject.created_by = created_by
        sourcingProject.description = description
        sourcingProject.estimate_budget = estimate_budget
        sourcingProject.target_saving = target_saving
        const valuePredecessor = {
          value: predecessors ? predecessors.id : '',
          label: predecessors
            ? `${predecessors.project_no} ${
                predecessors.project_no ? '-' : ''
              } ${predecessors.name}`
            : '',
        }
        const valuePurchasingCompanies = map(purchasing_companies || [], v => {
          return {
            value: v.id,
            label: `${v.code} ${v.code ? '-' : ''} ${v.name}`,
          }
        })
        const objCategories = categories
          ? {
              value: categories.ID || categories.id || '',
              label: categories.name || '',
            }
          : ''
        sourcingProject.categories =
          objCategories && objCategories.value ? objCategories : ''
        sourcingProject.target_date = targetDate
        sourcingProject.predecessors = valuePredecessor.value
          ? valuePredecessor
          : {
              value: null,
              label: 'No Select',
            }
        sourcingProject.project_reference = project_reference
        sourcingProject.internal_note = internal_note
        sourcingProject.purchasing_company_web = valuePurchasingCompanies
        const mapArrayFiles = this.funcMapFilesStatusProject(resultFiles)
        formData.sourcing_project_attachment_files_request = mapArrayFiles
        if (rfq_details) {
          const {
            name,
            event_type_id,
            description,
            purchasing_type_id,
            currency_id,
            is_vat,
            rfq_status_id,
            internal_note,
            seal_type,
            seal_status,
            start_date,
            end_date,
            note_to_supplier,
            id: idRfq,
            event_id,
          } = rfq_details
          const filesRfq = await this.funcGetInternalFileById(event_id)
          this.getProductById(event_id)
          const { step2 } = formData
          const { eventInformation } = step2
          const setTimeStartDate = start_date
            ? moment(start_date, 'YYYY/MM/DD HH:mm:ss').toDate()
            : null
          const setTimeEndDate = end_date
            ? moment(end_date, 'YYYY/MM/DD HH:mm:ss').toDate()
            : null
          const defaultTime = '0001-01-01 00:00:00 +0000 UTC'
          formData.start_date =
            start_date === defaultTime ? '' : setTimeStartDate
          formData.end_date = end_date === defaultTime ? '' : setTimeEndDate
          formData.note_to_supplier = note_to_supplier ? note_to_supplier : ''
          eventInformation.eventName = name
          formData.rfq_status_id = rfq_status_id
          eventInformation.eventType = event_type_id
          eventInformation.purchasingType = purchasing_type_id
          eventInformation.currency_id = currency_id
          eventInformation.description = description
          eventInformation.is_vat = is_vat
          eventInformation.internal_note = internal_note
          eventInformation.seal_status = seal_status
          eventInformation.seal_type = seal_type
          eventInformation.idRfq = idRfq
          eventInformation.is_BidType = rfq_details.bidding_type_id
          const mapArrayFiles = this.funcMapFilesStatus(filesRfq)
          eventInformation.internalFile = mapArrayFiles
          eventInformation.eventId = event_id
        }
        if (auction_details) {
          const filesRfq = await this.funcGetInternalFileById(
            auction_details.event_id
          )
          this.getProductById(auction_details.event_id)
          const { step2 } = formData
          const { eventInformation } = step2
          const setTimeStartDate = auction_details.start_date
            ? moment(auction_details.start_date, 'YYYY/MM/DD HH:mm:ss').toDate()
            : null
          const setTimeEndDate = auction_details.end_date
            ? moment(auction_details.end_date, 'YYYY/MM/DD HH:mm:ss').toDate()
            : null
          const defaultTime = '0001-01-01 00:00:00 +0000 UTC'
          formData.start_date =
            auction_details.start_date === defaultTime ? '' : setTimeStartDate
          formData.end_date =
            auction_details.end_date === defaultTime ? '' : setTimeEndDate
          formData.note_to_supplier = auction_details.note_to_supplier
            ? auction_details.note_to_supplier
            : ''
          eventInformation.eventName = auction_details.name
          eventInformation.auction_award_status_id =
            auction_details.auction_award_status_id
          eventInformation.auction_status_id = auction_details.auction_status_id
          eventInformation.auctionType = auction_details.auction_type_id
          eventInformation.eventType = auction_details.event_type_id
          eventInformation.purchasingType = auction_details.purchasing_type_id
          eventInformation.currency_id = auction_details.currency_id
          eventInformation.description = auction_details.description
          eventInformation.is_vat = auction_details.is_vat
          eventInformation.internal_note = auction_details.internal_note
          eventInformation.idAuction = auction_details.id
          eventInformation.idRfq = ''
          eventInformation.eventOpeningPrice = auction_details.opening_price
          eventInformation.eventReservePrice = auction_details.reserve_price
          eventInformation.is_bid = auction_details.is_min_bid_used
          eventInformation.bid_decrement =
            auction_details.bid_decrement_increment
          eventInformation.bid_minimum =
            auction_details.min_bid_decrement_increment
          eventInformation.is_ExtensionTime =
            auction_details.is_extension_time_used
          eventInformation.eventExtensionMinutes =
            auction_details.extension_minutes
          eventInformation.is_MaxExtension = auction_details.extension_time
            ? true
            : false
          eventInformation.eventExtensionTime = auction_details.extension_time
          eventInformation.is_HideLeadingBidAmount =
            auction_details.use_hide_leading_bid_reserve
          eventInformation.eventHideLeadingBidTime =
            auction_details.hide_leading_bid_time_before_close
          eventInformation.is_HideLeadingBidTime = auction_details.hide_leading_bid_time_before_close
            ? true
            : false
          eventInformation.is_BidType = auction_details.bidding_type_id
          eventInformation.is_display_dummy =
            auction_details.display_dummy_supplier_name
          const mapArrayFiles = this.funcMapFilesStatus(filesRfq)
          eventInformation.internalFile = mapArrayFiles
          eventInformation.eventId = auction_details.event_id
        }
        this.setState({ formData, isLoader: false })
      }
    } catch (error) {
      console.log(error)
      setTimeout(() => {
        toast.dismiss()
        this.props.history.push(ROUTE_PATH.HOME.LINK)
      }, 800)
    }
  }
  componentWillUnmount() {
    this._isMounted = false
    localStorage.removeItem('copy_event_eventid')
    document
      .getElementById('sourcing-add-supplier')
      .removeEventListener('scroll', this._handleScroll)
  }

  _handleScroll() {
    const offsetTrigger = 1
    const docElm = document.getElementById('sourcing-add-supplier')
    const scrollBottom =
      docElm.scrollHeight - (docElm.scrollTop + docElm.clientHeight)
    if (scrollBottom > offsetTrigger) {
      this.isScrollBottom = false
    } else if (scrollBottom < offsetTrigger && !this.isScrollBottom) {
      this.isScrollBottom = true
      this._onScrollBottom()
    }
  }

  _onScrollBottom() {
    if (
      this.state.paginationSupplierlist.page !==
      this.state.paginationSupplierlist.next_page
    )
      this.getMaster.getSupplierRqf(
        this.state.searchKeywords,
        this.state.paginationSupplierlist.next_page
      )
  }

  getMaster = {
    getBusinessCategory: async () => {
      const catBuyerId = localStorageService.getBuyerId()
      const params = {
        catBuyerId,
      }
      const businessCategory = await rfqController().getBusinessCategory(params)
      if (businessCategory) {
        let option = []
        businessCategory.map(e => {
          const data = { value: e.ID, label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          this.setState({ businessCategory: option })
        }
      } else {
        toastFail('error')
      }
    },
    getCurrency: async () => {
      let { currency } = this.state
      const resCurrency = await rfqController().getCurrencyByCompany()
      if (resCurrency) {
        if (resCurrency == '56003: currency is not found') {
          console.error(resCurrency)
        } else {
          resCurrency.map(e => {
            const data = { value: e.id, label: e.name }
            currency.push(data)
          })
          if (this._isMounted) {
            this.setState({ currency })
          }
        }
      } else {
        toastFail('error')
      }
    },
    getPurchasingCompany: async () => {
      const params = {
        sort_name: 'code',
        sort_by: 'asc',
      }
      const purchasingCompany = await purchasingSiteController().getPurchasingSite(
        params
      )
      if (purchasingCompany) {
        let option = []
        purchasingCompany.map(e => {
          const data = { value: e.id, label: `${e.code + ' - ' + e.name}` }
          option.push(data)
        })
        if (this._isMounted) {
          this.setState({ purchasingCompany: option })
        }
      } else {
        toastFail('error')
      }
    },
    getPurchasingTypes: async () => {
      const purchasingTypes = await rfqController().getPurchasingTypes()
      if (purchasingTypes) {
        let option = []
        purchasingTypes.map(e => {
          const data = { value: e.id, label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          this.setState({ purchasingTypes: option })
        }
      } else {
        toastFail('error')
      }
    },
    getUOM: async () => {
      const UOM = await rfqController().getUOM()
      if (UOM) {
        let option = []
        UOM.map(e => {
          const data = { value: e.id, label: e.name }
          option.push(data)
        })
        if (this._isMounted) {
          this.setState({ UOM: option })
        }
      } else {
        toastFail('error')
      }
    },
    getSupplierRqf: async (searchKeywords, page, onClickSearch) => {
      let {
        suppliersRfq,
        stackSelectSuppliersRfq,
        paginationSupplierlist,
      } = this.state
      const params = {
        search: searchKeywords.trim().replace(/[ ]+/, '%'),
        pagination: page,
      }
      if (this._isMounted) {
        this.setState({ stateSupplierRqfLoading: true })
      }
      const resSupplierRfq = await rfqController().getSupplierRfq(params)
      if (resSupplierRfq && resSupplierRfq.records) {
        paginationSupplierlist = {
          next_page: resSupplierRfq.next_page,
          page: resSupplierRfq.page,
        }
        const resSuppliersRfq = resSupplierRfq.records.map(sup => {
          return { ...sup, checked: false, disabled: false }
        })
        if (onClickSearch) {
          suppliersRfq = [...resSuppliersRfq]
        } else {
          suppliersRfq = [...suppliersRfq, ...resSuppliersRfq]
        }
        stackSelectSuppliersRfq.map(e => {
          const index = suppliersRfq.findIndex(
            sup => sup.SupplierID === e.SupplierID
          )

          const suppliersRfqDisabled = suppliersRfq.map(supRfq => {
            const selectSupplierRfqMatching =
              e.TaxID === supRfq.TaxID && e.SupplierID === supRfq.SupplierID
            const selectSupplierRfqDupplicate =
              e.TaxID === supRfq.TaxID && e.SupplierID !== supRfq.SupplierID

            if (selectSupplierRfqMatching) {
              return {
                ...supRfq,
                checked: true,
                disabled: false,
              }
            } else if (selectSupplierRfqDupplicate) {
              if (e.Branch === supRfq.Branch) {
                return { ...supRfq, disabled: true }
              } else {
                return { ...supRfq, disabled: false }
              }
            } else {
              return { ...supRfq }
            }
            // else {
            //   if (e.Branch === supRfq.Branch) {
            //     return { ...supRfq, disabled: true }
            //   } else {
            //     return { ...supRfq, disabled: false }
            //   }
            //   // return { ...supRfq }
            // }
          })
          suppliersRfq = suppliersRfqDisabled
          if (suppliersRfq[index]) {
            suppliersRfq[index].checked = true
          }
        })
        if (this._isMounted) {
          this.setState({
            paginationSupplierlist,
            suppliersRfq,
            stateSupplierRqfLoading: false,
          })
        }
      } else {
        toastFail('Not Found')
      }
    },
  }
  handleChangePurchasingSite = selected => {
    const { formData } = this.state
    formData.step1.sourcingProject.purchasing_company_web = selected
    if (this._isMounted) {
      this.setState({
        formData,
        isErrCompanyCode: false,
      })
    }
  }
  getRFQById = async id => {
    let { formData, purchasingCompany } = this.state
    try {
      const res = await rfqController().getRFQById(id)
      console.log(res)
      if (res) {
        formData = res
        // selected date momment
        const targetDateTime = res.target_date
        const startDateTime = res.start_date
        const endDateTime = res.end_date
        const targetDate = targetDateTime
          ? moment(targetDateTime, 'YYYY/MM/DD HH:mm:ss').toDate()
          : null
        const startDate = startDateTime
          ? moment(startDateTime, 'YYYY/MM/DD HH:mm:ss').toDate()
          : null
        const endDate = endDateTime
          ? moment(endDateTime, 'YYYY/MM/DD HH:mm:ss').toDate()
          : null
        formData.target_date = targetDate
        formData.start_date = startDate
        formData.end_date = endDate
        if (res.purchasing_company) {
          const options = []
          res.purchasing_company.map(e => {
            const optionsCompany = this.matchValueSelected(
              purchasingCompany,
              e.purchasing_company_id
            )
            if (optionsCompany) {
              options.push(optionsCompany)
            }
          })
          formData.purchasing_company_web = options
        }
        if (this._isMounted) {
          this.setState(
            { isEdit: true, formData },
            await this.getProductById(res.event_id)
          )
        }
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  copyRFQById = async id => {
    let { formData, purchasingCompany } = this.state
    try {
      const res = await rfqController().getRFQById(id)
      if (res) {
        formData = res
        formData.target_date = res.target_date
          ? new Date(res.target_date)
          : null
        formData.start_date = null
        formData.end_date = null
        if (res.purchasing_company) {
          const options = []
          res.purchasing_company.map(e => {
            const optionsCompany = this.matchValueSelected(
              purchasingCompany,
              e.purchasing_company_id
            )
            if (optionsCompany) {
              options.push(optionsCompany)
            }
          })
          formData.purchasing_company_web = options
          formData.event_id = res.event_id
        }
        if (this._isMounted) {
          this.setState({ formData }, await this.getProductById(res.event_id))
        }
      } else {
        toastFail('error')
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  getProductById = async (eventID, activePage = '') => {
    let { products, limit, editRoleDetail } = this.state
    let res
    // if (editRoleDetail) {
    //   let params = {
    //     page: 1,
    //     limit: limit,
    //   }
    //   res = await eventNewController().getEventItemById(eventID, params)
    // } else {
    let params = {
      page: activePage ? activePage : this.state.activePage,
      limit: editRoleDetail ? 1000 : limit,
    }

    res = await eventNewController().getEventItemById(eventID, params)

    if (res) {
      if (res.records && res.records.length > 0) {
        res.records.map((e, i) => {
          if (e.event_item_file.length > 0) {
            let checkFile = []
            e.event_item_file.map((file, k) =>
              checkFile.push({ ...file, is_deleted: false })
            )
            e.event_item_file = checkFile
          }
        })
        products.items = res.records
        if (this._isMounted) {
          this.setState({
            products,
            total_record: res.total_record,
            total_page: res.total_page,
            offset_page: res.offset,
          })
          if (!activePage) {
            // กด page ใหม่ ไม่ต้องเรียกเพิ่ม
            await this.getSupplierById(eventID)
          }
        }
      }
    } else {
      toastFail('error')
    }
  }

  getSupplierById = async eventID => {
    let res = await eventNewController().getEventSupplierById(eventID)
    if (res) {
      let list = []
      if (res && res.length > 0) {
        list = res.map((e, i) => {
          return {
            Branch: e.branch,
            CompanyName: e.company_name,
            ContactEmail: e.email,
            ContactName: e.name,
            ContactPhone: e.phone,
            VendorCode: e.vendor_code,
            StatusContact: 1,
            StatusSupplier: 1,
            SupplierID: e.supplier_id,
            TaxID: e.tax_id,
            checked: true,
            disabled: false,
          }
        })
      }
      if (this._isMounted) {
        this.setState(
          { selectSuppliersRfq: list, stackSelectSuppliersRfq: list },
          await this.getInternalFileById(eventID)
        )
      }
    } else {
      toastFail('error')
    }
  }

  getInternalFileById = async eventID => {
    // console.log('internalfile by id 2')
    let { internalFile } = this.state
    if (this._isMounted) {
      this.setState(
        { isEdit: true, internalFile },
        await this.getExternalFileById(eventID)
      )
    }
    // } else {
    //   toastFail('error')
    // }
  }

  getExternalFileById = async eventID => {
    let { externalFile } = this.state
    let res = await eventNewController().getExternalFileById(eventID)
    console.log({ res })
    if (res.length > 0) {
      externalFile = res.map(e => {
        var o = Object.assign({}, e)
        o.is_deleted = false
        return o
      })
      if (this._isMounted) {
        this.setState({ isEdit: true, externalFile })
      }
    } else if (res.status === 200 && res.data && res.data.result === null) {
      res = null
    } else {
      toastFail('error')
    }
  }

  matchValueSelected = (option, selectedId) => {
    if (option.length !== 0) {
      return option.find(value => value.value === selectedId)
    }
  }

  handleStepChange(step) {
    let { products, formData, activeStep, editRoleDetail } = this.state
    const { step2 } = formData
    const { eventInformation } = step2

    const checkStep2WithEventType2 =
      !eventInformation.eventName || eventInformation.auctionType === 1
        ? !eventInformation.eventOpeningPrice
        : true ||
          (!eventInformation.is_bid && !eventInformation.bid_decrement) ||
          (eventInformation.is_bid && !eventInformation.bid_minimum) ||
          (eventInformation.is_ExtensionTime &&
            !eventInformation.eventExtensionMinutes) ||
          (eventInformation.is_ExtensionTime &&
            eventInformation.is_MaxExtension &&
            !eventInformation.eventExtensionTime)

    const funcSetErrStep2EventType2 = () => {
      this.setState({
        isErrEventName: !eventInformation.eventName ? true : false,
        isErrOpeningPrice:
          eventInformation.auctionType === 1
            ? !eventInformation.eventOpeningPrice
              ? true
              : false
            : false,
        isErrBIDDecrement:
          !eventInformation.is_bid && !eventInformation.bid_decrement
            ? STRING.INVALID
            : false,
        isErrBIDMinimum:
          eventInformation.is_bid && !eventInformation.bid_minimum
            ? STRING.INVALID
            : false,
        isErrExtensionMinutes:
          eventInformation.is_ExtensionTime &&
          !eventInformation.eventExtensionMinutes
            ? true
            : false,
        isErrMaxExtensionTime:
          eventInformation.is_ExtensionTime &&
          eventInformation.is_MaxExtension &&
          !eventInformation.eventExtensionTime
            ? true
            : false,
      })
    }

    if (step === 2 && editRoleDetail) {
      if (eventInformation.eventType === 0) {
        if (
          eventInformation.eventName === '' ||
          eventInformation.eventType === 0
        ) {
          activeStep = 1
          this.setState({
            isErrEventType: eventInformation.eventType === 0 ? true : false,
            isErrEventName: eventInformation.eventName === '' ? true : false,
          })
        } else {
          activeStep = step
        }
      } else if (eventInformation.eventType === 1) {
        if (eventInformation.eventName === '') {
          activeStep = 1
        } else {
          activeStep = step
        }
      } else if (eventInformation.eventType === 2) {
        if (checkStep2WithEventType2) {
          activeStep = 1
          funcSetErrStep2EventType2()
        } else {
          activeStep = step
        }
      }
    } else if (step === 3 && editRoleDetail) {
      if (eventInformation.eventType === 0) {
        // eventType === 0 ยังไม่เลือก event type
        if (
          eventInformation.eventName === '' ||
          eventInformation.eventType === 0
        ) {
          activeStep = 1
          this.setState({
            isErrEventType: eventInformation.eventType === 0 ? true : false,
            isErrEventName: eventInformation.eventName === '' ? true : false,
          })
        } else if (products.items.length === 0) {
          activeStep = 2
        } else {
          activeStep = step
        }
      } else if (eventInformation.eventType === 1) {
        if (eventInformation.eventName === '') {
          activeStep = 1
        } else if (products.items.length === 0) {
          activeStep = 2
        } else {
          activeStep = step
        }
      } else if (eventInformation.eventType === 2) {
        if (checkStep2WithEventType2) {
          activeStep = 1
          funcSetErrStep2EventType2()
        } else if (products.items.length === 0) {
          activeStep = 2
        } else {
          activeStep = step
        }
      }
    } else {
      activeStep = step
    }
    if (this._isMounted) {
      return this.setState({ activeStep })
    }
  }

  nextStep() {
    if (this._isMounted) {
      return this.setState({
        activeStep: this.state.activeStep + 1,
        isErrName: false,
        isErrCategory: false,
        isErrPurchasingType: false,
        isErrProjectReference: false,
        isErrCompanyCode: false,
        isErrCurrency: false,
        irErrVat: false,
        isErrEstimateBudget: false,
        isErrTargetSaving: false,
        isErrTargetDate: false,
        isErrProductName: false,
        isErrProductQty: false,
        isErrProductBuget: false,
        isErrProductUOM: false,
        isErrStartDate: false,
        isErrEndDate: false,
        isErrMsgStartDate: '',
        isErrMsgEndDate: '',
        isErrMsgTargetDate: '',
        isErrMsgEstimateBudget: '',
      })
    }
  }

  previousStep() {
    if (this.state.activeStep > 0) {
      if (this._isMounted) {
        return this.setState({
          activeStep: this.state.activeStep - 1,
          isErrName: false,
          isErrCategory: false,
          isErrPurchasingType: false,
          isErrProjectReference: false,
          isErrCompanyCode: false,
          isErrCurrency: false,
          irErrVat: false,
          isErrEstimateBudget: false,
          isErrTargetSaving: false,
          isErrTargetDate: false,
          isErrProductName: false,
          isErrProductQty: false,
          isErrProductBuget: false,
          isErrProductUOM: false,
          isErrStartDate: false,
          isErrEndDate: false,
          isErrMsgStartDate: '',
          isErrMsgEndDate: '',
          isErrMsgTargetDate: '',
          isErrMsgEstimateBudget: '',
        })
      }
    }
  }

  toggleModal = (evt, id, name) => {
    if (this._isMounted) {
      return this.setState(
        prevState => ({
          ...prevState,
          modals: prevState.modals.map(modal => ({
            ...modal,
            isOpen: modal.name === evt ? !modal.isOpen : false,
          })),
        })
        // () => {
        //   console.log(this.state.modals)
        // }
      )
    }
  }

  // validateSaveDraft() {
  //   const {
  //     formData,
  //     activeStep,
  //     selectSuppliersRfq,
  //     internalFile,
  //   } = this.state
  //   if (
  //     activeStep === 0 &&
  //     Object.keys(formData).length === 3 &&
  //     internalFile.length === 0
  //   ) {
  //     return false
  //   } else if (
  //     activeStep === 2 &&
  //     selectSuppliersRfq.length === 0 &&
  //     !formData.supplier_ids &&
  //     !formData.start_date &&
  //     !formData.end_date &&
  //     !formData.note_to_supplier &&
  //     !formData.attachments_to_supplier
  //   ) {
  //     return false
  //   } else {
  //     if (this._isMounted) {
  //       this.setState({
  //         isErrName: false,
  //         isErrCategory: false,
  //         isErrPurchasingType: false,
  //         isErrProjectReference: false,
  //         isErrCompanyCode: false,
  //         isErrCurrency: false,
  //         irErrVat: false,
  //         isErrEstimateBudget: false,
  //         isErrTargetSaving: false,
  //         isErrTargetDate: false,
  //         isErrProductName: false,
  //         isErrProductQty: false,
  //         isErrProductBuget: false,
  //         isErrProductUOM: false,
  //         isErrStartDate: false,
  //         isErrEndDate: false,
  //         isErrMsgStartDate: '',
  //         isErrMsgEndDate: '',
  //         isErrMsgTargetDate: '',
  //         isErrMsgEstimateBudget: '',
  //       })
  //     }
  //     return true
  //   }
  // }

  validateSubmit() {
    const { formData, products, selectSuppliersRfq, auction_time } = this.state
    const { eventType } = this.state.formData.step2.eventInformation
    let {
      activeStep,
      isErrName,
      isErrCategory,
      isErrPurchasingType,
      isErrProjectReference,
      isErrCompanyCode,
      isErrCurrency,
      isErrEstimateBudget,
      isErrTargetSaving,
      isErrTargetDate,
      isErrStartDate,
      isErrEndDate,
      isErrMsgStartDate,
      isErrMsgEndDate,
      isErrMsgTargetDate,
    } = this.state
    let isPass = true

    isErrMsgStartDate = ''
    isErrMsgEndDate = ''
    isErrMsgTargetDate = ''
    isErrStartDate = false
    isErrEndDate = false
    const dateNow = new Date().setHours(0, 0, 0, 0)
    const startDate = moment(formData.start_date)
    const endDate = moment(formData.end_date)
    const startDateString = moment(formData.start_date).format(
      'DD/MM/YYYY HH:mm'
    )
    const endDateString = moment(formData.end_date).format('DD/MM/YYYY HH:mm')

    if (formData.target_date < dateNow) {
      isErrMsgTargetDate = 'Target Date must be after current time'
      isErrTargetDate = true
      isPass = false
      activeStep = 0
    }

    if (products.items.length === 0) {
      toastFail('Please select at least 1 product')
      isPass = false
      activeStep = 1
    }
    if (eventType === 1 && selectSuppliersRfq.length === 0) {
      toastFail('Please select at least 1 supplier')
      isPass = false
    }
    if (eventType === 2 && selectSuppliersRfq.length <= 1) {
      toastFail('Please select at least 2 suppliers')
      isPass = false
    }

    if (!formData.start_date) {
      isErrStartDate = true
      isPass = false
    }

    if (!formData.end_date) {
      isErrEndDate = true
      isPass = false
    }

    if (formData.start_date || formData.end_date) {
      if (eventType === 1) {
        if (endDate <= Date.now()) {
          isErrMsgEndDate = 'End date must be after current time'
          isErrEndDate = true
          isPass = false
        }

        if (startDate <= Date.now()) {
          isErrMsgStartDate = 'Start date must be after current time'
          isErrStartDate = true
          isPass = false
        }
      }

      if (eventType === 2) {
        // console.log(
        //   'check time',
        //   startDate.diff(moment(), 'hours')
        // )
        if (startDate.diff(moment(), 'hours') < auction_time) {
          isErrMsgStartDate = `Start date must be after current time ${auction_time} hours`
          isErrStartDate = true
          isPass = false
        }
      }

      if (startDateString === endDateString || startDate > endDate) {
        isErrMsgEndDate = 'End date must be after Start date'
        isErrEndDate = true
        isPass = false
      }
    }

    if (this._isMounted) {
      this.setState({
        activeStep,
        isErrName,
        isErrCategory,
        isErrPurchasingType,
        isErrProjectReference,
        isErrCompanyCode,
        isErrCurrency,
        isErrEstimateBudget,
        isErrTargetSaving,
        isErrTargetDate,
        isErrStartDate,
        isErrEndDate,
        isErrMsgStartDate,
        isErrMsgEndDate,
        isErrMsgTargetDate,
      })
    }
    return isPass
  }
  validateSaveDraft = () => {
    let { formData, activeStep, products, isLoading } = this.state
    let isPass = true
    const toastError = 'Please fill in at least one field'
    const funcControValidStep1 = () => {
      let isErrName = false
      let isErrEstimateBudget = false
      let isErrMsgEstimateBudget = ''
      let isErrCategory = false
      let isErrTargetDate = false
      let isErrMsgTargetDate = ''
      let isErrCompanyCode = false
      const { step1, sourcing_project_attachment_files_request } = formData
      const {
        name,
        estimate_budget,
        categories,
        target_date,
        purchasing_company_web,
      } = step1.sourcingProject
      const funcValidateStep = () => {
        if (
          name ||
          estimate_budget ||
          categories ||
          target_date ||
          purchasing_company_web ||
          sourcing_project_attachment_files_request.length !== 0
        ) {
          if (name === '') {
            isPass = false
            this.setState({ isLoader: false })
            toast.error(toastError)
          } else {
            isPass = true
          }
        } else {
          isPass = false
          this.setState({ isLoader: false })
          toast.error(toastError)
        }
      }
      if (activeStep === 0) {
        funcValidateStep()
      }
    }
    const funcControValidStep2 = () => {
      let isErrEventType = false
      let isErrEventName = false
      let isErrPurchasingType = false
      const { step2 } = formData
      const {
        eventType,
        purchasingType,
        eventName,
        currency_id,
        description,
        seal_type,
        internal_note,
        eventOpeningPrice,
        bid_decrement,
        bid_minimum,
        eventExtensionMinutes,
        eventExtensionTime,
      } = step2.eventInformation
      const funcValidateStep = () => {
        if (
          eventName ||
          description ||
          seal_type ||
          internal_note ||
          eventOpeningPrice ||
          bid_minimum ||
          bid_decrement ||
          eventExtensionMinutes ||
          eventExtensionTime
        ) {
          isPass = true
        } else {
          isPass = false
          this.setState({ isLoader: false })
          toast.error(toastError)
        }
      }
      if (activeStep === 1) {
        funcValidateStep()
      }
    }
    const funcControValidStep3 = () => {
      let isErrProductName = false
      let isErrProductQty = false
      let isErrProductBuget = false
      let isErrProductUOM = false
      const funcValidateStep = () => {
        if (products.items.length !== 0) {
          isPass = true
        } else {
          isPass = false
          this.setState({ isLoader: false })
          toast.error(toastError)
        }
      }
      if (activeStep === 2) {
        funcValidateStep()
      }
    }
    const funcControValidStep4 = () => {
      const {
        selectSuppliersRfq,
        externalFile,
        formData,
        auction_time,
      } = this.state
      const { eventType } = formData.step2.eventInformation
      const dateNow = new Date().setHours(0, 0, 0, 0)
      let isErrStartDate = false
      let isErrEndDate = false
      let isErrMsgEndDate = ''
      let isErrMsgStartDate = ''
      const startDate = moment(formData.start_date)
      const endDate = moment(formData.end_date)
      const startDateString = moment(formData.start_date).format(
        'DD/MM/YYYY HH:mm'
      )
      const endDateString = moment(formData.end_date).format('DD/MM/YYYY HH:mm')

      if (activeStep === 3) {
        if (
          selectSuppliersRfq.length !== 0 ||
          (formData.start_date && formData.end_date) ||
          formData.note_to_supplier ||
          externalFile.length !== 0
        ) {
          if (externalFile.length !== 0) {
            isPass = true
          }

          if (formData.note_to_supplier) {
            isPass = true
          }

          if (selectSuppliersRfq.length !== 0) {
            isPass = true
          }

          if (!formData.start_date) {
            isErrStartDate = true
            isPass = false
          }

          if (!formData.end_date) {
            isErrEndDate = true
            isPass = false
          }

          if (formData.start_date || formData.end_date) {
            if (eventType === 1) {
              if (endDate <= Date.now()) {
                isErrMsgEndDate = 'End date must be after current time'
                isErrEndDate = true
                isPass = false
              }

              if (startDate <= Date.now()) {
                isErrMsgStartDate = 'Start date must be after current time'
                isErrStartDate = true
                isPass = false
              }
            }

            if (eventType === 2) {
              if (startDate.diff(moment(), 'hours') < auction_time) {
                isErrMsgStartDate = `Start date must be after current time ${auction_time} hours`
                isErrStartDate = true
                isPass = false
              }
            }

            if (startDateString === endDateString || startDate > endDate) {
              isErrMsgEndDate = 'End date must be after Start date'
              isErrEndDate = true
              isPass = false
            }
          }

          if (
            isErrEndDate ||
            isErrMsgEndDate ||
            isErrStartDate ||
            isErrMsgStartDate
          ) {
            this.setState({ isLoader: false })
          }

          this.setState({
            isErrEndDate,
            isErrMsgEndDate,
            isErrStartDate,
            isErrMsgStartDate,
          })
        } else {
          isPass = false
          this.setState({ isLoader: false })
          toast.error(toastError)
        }
      }
    }
    funcControValidStep1()
    funcControValidStep2()
    funcControValidStep3()
    funcControValidStep4()

    return isPass
  }
  validateActiveStep() {
    const { formData, activeStep, products } = this.state
    let isPassStep = true
    const controlFuncStep = () => {
      switch (activeStep) {
        case 1: {
          const funcValidateStep2 = () => {
            let isErrEventType,
              isErrPurchasingType,
              isErrEventName,
              isErrOpeningPrice,
              isErrBid,
              isErrMaxExtensionTime,
              isErrExtensionMinutes,
              isErrBIDDecrement,
              isErrBIDMinimum,
              isErrHideLeadingBidTime = false
            const { step2 } = formData
            const {
              eventType,
              purchasingType,
              eventName,
              auctionType,
              eventOpeningPrice,
              is_ExtensionTime,
              is_MaxExtension,
              eventExtensionTime,
              eventExtensionMinutes,
              is_bid,
              bid_decrement,
              bid_minimum,
              is_BidType,
              is_HideLeadingBidTime,
              eventHideLeadingBidTime,
            } = step2.eventInformation
            const funcCheckEventType = () => {
              if (!eventType) {
                isErrEventType = true
                isPassStep = false
              }
            }
            const funcCheckPurchasingType = () => {
              if (eventType === 1 && !purchasingType) {
                isErrPurchasingType = true
                isPassStep = false
              }
            }
            const funcCheckEventName = () => {
              if (!eventName) {
                isErrEventName = true
                isPassStep = false
              }
            }
            const funcCheckAuction = () => {
              if (eventType === 2) {
                if (auctionType === 1) {
                  if (!eventOpeningPrice || eventOpeningPrice <= 0) {
                    isErrOpeningPrice = true
                    isPassStep = false
                  }
                }

                if (is_bid) {
                  if (!bid_minimum) {
                    isErrBIDMinimum = STRING.INVALID
                    isPassStep = false
                  }
                } else {
                  if (!bid_decrement) {
                    isErrBIDDecrement = STRING.INVALID
                    isPassStep = false
                  }
                }

                if (is_ExtensionTime) {
                  if (!eventExtensionMinutes) {
                    isErrExtensionMinutes = true
                    isPassStep = false
                  }
                  if (is_MaxExtension) {
                    if (!eventExtensionTime) {
                      isErrMaxExtensionTime = true
                      isPassStep = false
                    }
                  }
                }

                if (is_BidType === 1) {
                  if (eventOpeningPrice) {
                    if (!is_bid && bid_decrement >= eventOpeningPrice) {
                      isErrBIDDecrement = 'Less than Opening Price'
                      isPassStep = false
                    }
                    if (is_bid && bid_minimum >= eventOpeningPrice) {
                      isErrBIDMinimum = 'Less than Opening Price'
                      isPassStep = false
                    }
                  }
                }

                if (auctionType === 2) {
                  if (is_HideLeadingBidTime && !eventHideLeadingBidTime) {
                    isErrHideLeadingBidTime = STRING.INVALID
                    isPassStep = false
                  }
                }
              }
            }

            const funcSetState = () => {
              if (this._isMounted) {
                this.setState({
                  isErrEventType,
                  isErrPurchasingType,
                  isErrEventName,
                  isErrOpeningPrice,
                  isErrBid,
                  isErrMaxExtensionTime,
                  isErrExtensionMinutes,
                  isErrBIDDecrement,
                  isErrBIDMinimum,
                  isErrHideLeadingBidTime,
                })
              }
            }
            if (this.state.editRoleDetail) {
              funcCheckEventType()
              funcCheckPurchasingType()
              funcCheckEventName()
              funcCheckAuction()
              funcSetState()
            }
            return isPassStep
          }
          return funcValidateStep2()
        }
        case 2: {
          const funcValidateStep3 = () => {
            const { items } = products
            let isErrProductName = false
            let isErrProductQty = false
            let isErrProductBuget = false
            let isErrProductUOM = false
            const funcCheckProductName = () => {
              if (items.length === 0) {
                isErrProductName = true
                isPassStep = false
              }
            }
            const funcReqAmount = () => {
              if (items.length === 0) {
                isPassStep = false
                isErrProductQty = true
              }
            }
            const funcCheckBudgetPrice = () => {
              if (items.length === 0) {
                isPassStep = false
                isErrProductBuget = true
              }
            }
            const funcCheckUomId = () => {
              if (items.length === 0) {
                isPassStep = false
                isErrProductUOM = true
              }
            }
            const funcSetState = () => {
              if (this._isMounted) {
                return this.setState({
                  isErrProductName,
                  isErrProductQty,
                  isErrProductBuget,
                  isErrProductUOM,
                })
              }
            }
            if (this.state.editRoleDetail) {
              funcCheckProductName()
              funcReqAmount()
              funcCheckBudgetPrice()
              funcCheckUomId()
              funcSetState()
            }
            return isPassStep
          }
          return funcValidateStep3()
        }
        default: {
          const funcValidateStep1 = () => {
            let isErrName = false
            let isErrCategory = false
            let irErrVat = false
            let isErrPurchasingType = false
            let isErrProjectReference = false
            let isErrCompanyCode = false
            let isErrCurrency = false
            let isErrEstimateBudget = false
            let isErrTargetSaving = false
            let isErrTargetDate = false
            let isErrMsgTargetDate = ''
            let isErrMsgEstimateBudget = ''
            let isErrStartDate = false
            let isErrEndDate = false
            let isErrMsgEndDate = ''
            let isErrMsgStartDate = ''
            const { step1 } = formData
            const {
              name,
              categories,
              purchasing_company_web,
              estimate_budget,
              target_date,
              target_saving,
            } = step1.sourcingProject
            const funcCheckSourcingProjectName = () => {
              if (!name || name === '') {
                isErrName = true
                isPassStep = false
              }
            }
            const funcCheckRfqCategoryId = () => {
              if (!categories) {
                isErrCategory = true
                isPassStep = false
              }
            }
            const funcCheckPurchasingCompany = () => {
              if (!purchasing_company_web) {
                isErrCompanyCode = true
                isPassStep = false
              } else if (purchasing_company_web.length === 0) {
                isErrCompanyCode = true
                isPassStep = false
              }
            }
            const funcCheckEstimateBudget = () => {
              if (!estimate_budget) {
                isErrEstimateBudget = true
                isPassStep = false
              } else if (estimate_budget <= 0) {
                isErrEstimateBudget = true
                isPassStep = false
                isErrMsgEstimateBudget = 'Please fill in more than 0 '
              }
              if (target_saving && target_saving > 100) {
                isErrTargetSaving = true
                isPassStep = false
              }
            }
            const funcCheckTargetdate = () => {
              const dateNow = new Date().setHours(0, 0, 0, 0)
              if (!target_date) {
                isErrTargetDate = true
                isPassStep = false
              } else if (target_date < dateNow) {
                isErrMsgTargetDate = 'Target Date must be after current time'
                isErrTargetDate =
                  this.state.getCreatenewround || !this.state.editRoleDetail
                    ? false
                    : true
                isPassStep =
                  this.state.getCreatenewround || !this.state.editRoleDetail
                    ? true
                    : false
              }
            }
            const funcSetState = () => {
              if (this._isMounted) {
                this.setState({
                  isErrName,
                  isErrCategory,
                  isErrProjectReference,
                  isErrCompanyCode,
                  isErrCurrency,
                  isErrEstimateBudget,
                  isErrTargetSaving,
                  isErrTargetDate,
                  irErrVat,
                  isErrMsgEndDate,
                  isErrMsgTargetDate,
                  isErrMsgEstimateBudget,
                })
              }
            }
            if (this.state.editRoleDetail) {
              funcCheckSourcingProjectName()
              funcCheckRfqCategoryId()
              funcCheckPurchasingCompany()
              funcCheckEstimateBudget()
              funcCheckTargetdate()
              funcSetState()
            }
            return isPassStep
          }
          return funcValidateStep1()
        }
      }
    }
    const validateControl = controlFuncStep()
    return validateControl
  }
  validateProduct() {
    const { formProduct } = this.state
    let {
      isErrProductName,
      isErrProductQty,
      isErrProductBuget,
      isErrProductUOM,

      isErrMsgProductBuget,
      isErrMsgProductMarket,
      isErrMsgProductHistorical,
      isErrMsgProductQty,
    } = this.state

    isErrProductName = false
    isErrProductQty = false
    isErrProductBuget = false
    isErrProductUOM = false

    isErrMsgProductBuget = ''
    isErrMsgProductMarket = ''
    isErrMsgProductHistorical = ''
    isErrMsgProductQty = ''
    let isPass = true
    if (!formProduct.name) {
      isPass = false
      isErrProductName = true
    }
    if (!formProduct.req_amount || formProduct.req_amount <= 0) {
      isPass = false
      isErrProductQty = true
    }

    if (formProduct.req_amount && formProduct.req_amount > 100000000) {
      isErrMsgProductQty = 'Value must be less than to 100,000,000'
      isPass = false
      isErrProductQty = true
    }

    if (!formProduct.budget_price || formProduct.budget_price <= 0) {
      isPass = false
      isErrProductBuget = true
    } else if (formProduct.budget_price > 10000000000) {
      isErrMsgProductBuget = 'Value must be less than to 10,000,000,000'
      isPass = false
      isErrProductBuget = true
    }

    if (
      formProduct.budget_price &&
      formProduct.historical_price > 10000000000
    ) {
      isErrMsgProductHistorical = 'Value must be less than to 10,000,000,000'
      isPass = false
    }

    if (formProduct.market_price && formProduct.market_price > 10000000000) {
      isErrMsgProductMarket = 'Value must be less than to 10,000,000,000'
      isPass = false
    }

    if (formProduct.uom_id === null) {
      isPass = false
      isErrProductUOM = true
    }
    if (this._isMounted) {
      this.setState({
        isErrProductName,
        isErrProductQty,
        isErrProductBuget,
        isErrProductUOM,
        isErrMsgProductBuget,
        isErrMsgProductMarket,
        isErrMsgProductHistorical,
        isErrMsgProductQty,
      })
    }
    return isPass
  }
  funcCheckProjectStatus = id => {
    let statusName = ''
    switch (id) {
      case 1: {
        statusName = 'Draft'
        return statusName
      }
      case 2: {
        statusName = 'WIP'
        return statusName
      }
      case 3: {
        statusName = 'Cancelled'
        return statusName
      }
      case 4: {
        statusName = 'Completed'
        return statusName
      }
      default:
        break
    }
  }
  setDataSendApi() {
    const { match } = this.props
    const { idproject, eventid } = match.params
    console.log('eventid', eventid)

    const {
      isEdit,
      formData,
      purchasingCompany,
      activeStep,
      products,
      selectSuppliersRfq,
      externalFile,
      suppliersRfq,
      stackSelectSuppliersRfq,
      clicks,
    } = this.state
    const defaultTime = moment(new Date(), 'YYYY/MM/DD HH:mm:ss').toDate()
    const { items } = products
    const { step1, step2, start_date, end_date, note_to_supplier } = formData
    const { id, rfq_status_id } = formData
    const { sourcing_project_attachment_files_request } = formData
    const {
      predecessors,
      project_no,
      project_status_id,
      target_date,
      description,
      estimate_budget,
      target_saving,
      categories,
      project_reference,
      internal_note: step1InternalNote,
      purchasing_company_web,
      name,
      cancel_reason,
    } = step1.sourcingProject
    const {
      eventType,
      eventName,
      currency_id,
      description: step2Description,
      is_vat,
      internal_note: step2InternalNote,
      internalFile: internalFileStep2,
      seal_status,
      idRfq,
      purchasingType,
      seal_type,

      // data Auction
      is_BidType,
      idAuction,
      auctionType,
      eventOpeningPrice,
      eventReservePrice,
      is_ExtensionTime,
      eventExtensionMinutes,
      is_MaxExtension,
      eventExtensionTime,
      is_display_dummy,
      auction_award_status_id,
      auction_status_id,
      // Auction type seal
      eventHideLeadingBidTime,
      is_HideLeadingBidAmount,
      is_bid,
      bid_decrement,
      bid_minimum,
      eventId,
    } = step2.eventInformation
    const objPredecessors = {
      id: predecessors.value,
      name: predecessors.label,
    }
    const objCategory = {
      id: categories.value,
      name: categories.label,
    }
    const mapArrPurchasingCompany = map(purchasing_company_web, (v, k) => {
      return {
        id: v.value,
        name: v.label,
      }
    })
    const filterPurchasingCompany = filter(
      mapArrPurchasingCompany,
      (v, k) => v.id !== 'All'
    )
    const objSendApi = () => {
      let objStep = () => {
        let items_list = []
        // console.log('items', items)
        if (items && items.length > 0) {
          items_list = items.map((item, i) => {
            let items_id = ''
            if (item.event_id === formData.step2.eventInformation.eventId) {
              items_id = item.id
            }
            return {
              id: items_id,
              name: item.name,
              description: item.description,
              uom_id: item.uom_id,
              uom_name: item.uom,
              req_amount: item.req_amount,
              historical_price: item.historical_price,
              budget_price: item.budget_price,
              market_price: item.market_price,
              ...(eventType && {
                event_item_files: item.event_item_file || [],
              }),
            }
          })
        }
        const step2 = () => {
          if (
            eventName ||
            eventType ||
            purchasingType ||
            currency_id ||
            step2Description ||
            is_vat ||
            seal_type ||
            step2InternalNote ||
            internalFileStep2.length !== 0
          ) {
            if (
              eventType !== 0 ||
              (idproject && eventid) ||
              (idproject && !eventid)
            ) {
              console.log('event inform', formData.step2.eventInformation)
              return {
                ...(eventType && {
                  event: {
                    ...(eventId && { id: eventId }),
                    event_type_id: eventType ? eventType : 1,
                    ...(eventName && { name: eventName }),
                    ...(step2Description && { description: step2Description }),
                    purchasing_type_id: purchasingType ? purchasingType : 1,
                    bidding_type_id: is_BidType,
                    currency_id: currency_id,
                    is_vat: is_vat ? is_vat : false,
                    status_id: rfq_status_id
                      ? rfq_status_id
                      : auction_status_id,
                    ...(step2InternalNote && {
                      internal_note: step2InternalNote,
                    }),
                    ...(start_date && { start_date: start_date }),
                    ...(end_date && { end_date: end_date }),
                    ...(seal_type && { seal_type: seal_type }),
                    ...(seal_status && { seal_status: seal_status }),
                    is_cancel: false, // ui step 4
                    note_approve: '',
                    ...(note_to_supplier && {
                      note_to_supplier: note_to_supplier,
                    }),
                    ...(eventType === 2 && {
                      auction_status_id: auction_status_id,
                      auction_award_status_id: auction_award_status_id,
                      auction_type_id: auctionType,
                      display_dummy_supplier_name: is_display_dummy,
                      ...(eventOpeningPrice && {
                        opening_price: eventOpeningPrice,
                      }),
                      ...(eventReservePrice && {
                        reserve_price: eventReservePrice,
                      }),
                      is_min_bid_used: is_bid,
                      bid_decrement_increment:
                        !is_bid && bid_decrement ? bid_decrement : null,
                      min_bid_decrement_increment:
                        is_bid && bid_minimum ? bid_minimum : null,
                      is_extension_time_used: is_ExtensionTime,
                      extension_time: eventExtensionTime
                        ? eventExtensionTime
                        : null,
                      extension_minutes: eventExtensionMinutes
                        ? eventExtensionMinutes
                        : null,
                    }),
                  },
                }),
                ...(internalFileStep2.length !== 0 && {
                  event_internal_files: internalFileStep2,
                }),
              }
            }
          } else {
            return {}
          }
        }
        const step3 = () => {
          if (items) {
            return {
              // ...(eventType === 1 && { rfq_items: { items: items_list } }),
              // ...(eventType === 2 && {
              //   auction_items: { items: items_list },
              // }),
              ...(eventType && { event_items: items_list }),
            }
          } else {
            return {}
          }
        }
        const step4 = () => {
          if (selectSuppliersRfq) {
            let params = {}
            let supplierList = []
            const filterSup = filter(
              selectSuppliersRfq,
              value => value !== undefined
            )
            map(filterSup, (e, i) => {
              // const supplier = {}
              // supplier.supplier_id = e.SupplierID
              supplierList.push(e.SupplierID)
            })
            // if (eventType === 1) {
            //   params.rfq_supplier = []
            //   params.rfq_id = idRfq
            //   params.rfq_status_id = rfq_status_id
            //   const filterSup = filter(
            //     selectSuppliersRfq,
            //     value => value !== undefined
            //   )
            //   map(filterSup, (e, i) => {
            //     const supplier = {}
            //     supplier.supplier_id = e.SupplierID
            //     params.rfq_supplier.push(supplier)
            //   })
            // }
            // if (eventType === 2) {
            //   params.auction_supplier = []
            //   params.auction_id = formData.step2.eventInformation.idAuction
            //   params.auction_status_id =
            //     formData.step2.eventInformation.auction_status_id
            //   const filterSup = filter(
            //     selectSuppliersRfq,
            //     value => value !== undefined
            //   )
            //   map(filterSup, (e, i) => {
            //     const supplier = {}
            //     supplier.supplier_id = e.SupplierID
            //     params.auction_supplier.push(supplier)
            //   })
            // }
            return {
              // ...(eventType === 1 && { suppliers: params }),
              // ...(eventType === 2 && { auction_suppliers: params }),
              // ...(eventType === 1 && {
              //   rfq_external: externalFile ? externalFile : [],
              // }),
              // ...(eventType === 2 && {
              //   auction_external: externalFile ? externalFile : [],
              // }),
              ...(eventType && {
                suppliers: supplierList,
                event_external_files: externalFile ? externalFile : [],
              }),

              // rfq_external: externalFile ? externalFile : [],
            }
          } else {
            return {
              // rfq_external: externalFile ? externalFile : [],
              // ...(eventType === 1 && {
              //   rfq_external: externalFile ? externalFile : [],
              // }),
              // ...(eventType === 2 && {
              //   auction_external: externalFile ? externalFile : [],
              // }),
              ...(eventType && {
                // suppliers: params,
                event_external_files: externalFile ? externalFile : [],
              }),
            }
          }
        }
        let idCheck = formData.id ? formData.id : ''
        if (match.params && !formData.id) {
          if (match.params.idproject && match.params.eventid) {
            idCheck = ''
          } else if (match.params.idproject) {
            idCheck = match.params.idproject
          }
          if (match.params.id) {
            idCheck = match.params.id
          }
        }
        let clearSourcingId = ''
        if (step2() && step2().rfq && eventType === 1) {
          clearSourcingId = formData.step2.eventInformation.idAuction
        }
        if (step2() && step2().auction && eventType === 2) {
          clearSourcingId = formData.step2.eventInformation.idRfq
        }
        return {
          sourcing_project: {
            ...(idCheck && { id: idCheck }),
            ...(name && { name: name }),
            project_status_id: clicks === 1 ? 2 : project_status_id,
            ...(description && { description: description }),
            ...(step1InternalNote && { internal_note: step1InternalNote }),
            ...(target_date && { target_date: target_date }),
            ...(estimate_budget && { estimate_budget: estimate_budget }),
            ...(target_saving && { target_saving: target_saving }),
            ...(project_reference && { project_reference: project_reference }),
            ...(objPredecessors.id && { predecessor: objPredecessors }),
            ...(categories && { category: objCategory }),
            ...(filterPurchasingCompany.length !== 0 && {
              purchasing_companies: filterPurchasingCompany,
            }),
          },
          ...(clearSourcingId && {
            clear_sourcing_id: clearSourcingId,
          }),
          sourcing_project_attachment_files: sourcing_project_attachment_files_request,
          ...step2(),
          ...step3(),
          ...step4(),
        }
      }
      const result = objStep()
      console.log('result', result)
      return result
    }
    const resultObj = objSendApi()
    // if (formData.id) {
    //   resultObj.id = formData.id
    // }
    // console.log('resultObj', resultObj)
    // return
    return resultObj
  }
  async funcFetchCreateProjectStep(id, eventid = '') {
    if (this._isMounted) {
      const { formData } = this.state
      const obj = {
        id,
        eventId: eventid ? eventid : '',
      }
      try {
        const res = await rfqController().getSourcingProject(obj)
        if (res) {
          const {
            project_no,
            project_status_id,
            created_at,
            id,
            description,
            estimate_budget,
            target_saving,
            categories,
            predecessors,
            project_reference,
            internal_note,
            purchasing_companies,
            target_date,
            rfq_details,
            auction_details,
            name,
          } = res
          const resultFiles = await this.funcGetInternalFileProject(id)
          if (rfq_details) {
            await this.getExternalFileById(rfq_details.event_id)
          } else if (auction_details) {
            await this.getExternalFileById(auction_details.event_id)
          }
          const arrCategories = [categories]
          const valueCategories = this.matchValueSelected(arrCategories)
          const objCategories = {
            value: valueCategories.ID,
            label: valueCategories.name,
          }
          const valuePredecessor = {
            value: predecessors ? predecessors.id : '',
            label: predecessors
              ? `${predecessors.project_no} ${
                  predecessors.project_no ? '-' : ''
                } ${predecessors.name}`
              : '',
          }
          const valuePurchasingCompanies = map(purchasing_companies, (v, k) => {
            return {
              value: v.id,
              label: `${v.code} ${v.code ? '-' : ''} ${v.name}`,
            }
          })
          const setTimeTargetDate = target_date
            ? moment(target_date, 'YYYY/MM/DD HH:mm:ss').toDate()
            : null
          const projectStatus = this.funcCheckProjectStatus(project_status_id)
          const createdAt = moment(created_at).format('MMM DD, YYYY hh:mm A')
          formData.step1.sourcingProject.project_no = project_no
          formData.step1.sourcingProject.project_status_name = projectStatus
          formData.step1.sourcingProject.createDate = createdAt
          formData.step1.sourcingProject.target_date = setTimeTargetDate
          formData.step1.sourcingProject.name = name
          formData.step1.sourcingProject.description = description
          formData.step1.sourcingProject.estimate_budget = estimate_budget
          formData.step1.sourcingProject.target_saving = target_saving
          formData.step1.sourcingProject.categories = objCategories.value
            ? objCategories
            : ''
          formData.id = id
          formData.step1.sourcingProject.predecessors = valuePredecessor.value
            ? valuePredecessor
            : ''
          formData.step1.sourcingProject.project_reference = project_reference
          formData.step1.sourcingProject.internal_note = internal_note
          formData.step1.sourcingProject.purchasing_company_web = valuePurchasingCompanies
          const mapArrayFiles = this.funcMapFilesStatusProject(resultFiles)
          formData.sourcing_project_attachment_files_request = mapArrayFiles
          if (rfq_details) {
            const {
              name,
              event_type_id,
              description,
              purchasing_type_id,
              currency_id,
              is_vat,
              rfq_status_id,
              internal_note,
              seal_type,
              seal_status,
              start_date,
              end_date,
              note_to_supplier,
              id: idRfq,
              event_id,
            } = rfq_details
            const filesRfq = await this.funcGetInternalFileById(event_id)
            this.getProductById(event_id)
            const { step2 } = formData
            const { eventInformation } = step2
            const setTimeStartDate = start_date
              ? moment(start_date, 'YYYY/MM/DD HH:mm:ss').toDate()
              : null
            const setTimeEndDate = end_date
              ? moment(end_date, 'YYYY/MM/DD HH:mm:ss').toDate()
              : null
            const defaultTime = '0001-01-01 00:00:00 +0000 UTC'
            formData.start_date =
              start_date === defaultTime ? '' : setTimeStartDate
            formData.end_date = end_date === defaultTime ? '' : setTimeEndDate
            formData.note_to_supplier = note_to_supplier ? note_to_supplier : ''
            eventInformation.eventName = name
            formData.rfq_status_id = rfq_status_id
            eventInformation.eventType = event_type_id
            eventInformation.purchasingType = purchasing_type_id
            eventInformation.currency_id = currency_id
            eventInformation.description = description
            eventInformation.is_vat = is_vat
            eventInformation.internal_note = internal_note
            eventInformation.seal_status = seal_status
            eventInformation.seal_type = seal_type
            eventInformation.idRfq = idRfq
            eventInformation.idAuction = ''
            eventInformation.is_BidType = rfq_details.bidding_type_id
            const filesEvent = this.funcMapFilesStatus(filesRfq)
            eventInformation.internalFile = filesEvent
            eventInformation.eventId = event_id
          }
          if (auction_details) {
            const filesRfq = await this.funcGetInternalFileById(
              auction_details.event_id
            )
            this.getProductById(auction_details.event_id)
            const { step2 } = formData
            const { eventInformation } = step2
            const setTimeStartDate = auction_details.start_date
              ? moment(
                  auction_details.start_date,
                  'YYYY/MM/DD HH:mm:ss'
                ).toDate()
              : null
            const setTimeEndDate = auction_details.end_date
              ? moment(auction_details.end_date, 'YYYY/MM/DD HH:mm:ss').toDate()
              : null
            const defaultTime = '0001-01-01 00:00:00 +0000 UTC'
            formData.start_date =
              auction_details.start_date === defaultTime ? '' : setTimeStartDate
            formData.end_date =
              auction_details.end_date === defaultTime ? '' : setTimeEndDate
            formData.note_to_supplier = auction_details.note_to_supplier
              ? auction_details.note_to_supplier
              : ''
            eventInformation.eventName = auction_details.name
            eventInformation.auction_award_status_id =
              auction_details.auction_award_status_id
            eventInformation.auction_status_id =
              auction_details.auction_status_id
            eventInformation.auctionType = auction_details.auction_type_id
            eventInformation.eventType = auction_details.event_type_id
            eventInformation.purchasingType = auction_details.purchasing_type_id
            eventInformation.currency_id = auction_details.currency_id
            eventInformation.description = auction_details.description
            eventInformation.is_vat = auction_details.is_vat
            eventInformation.internal_note = auction_details.internal_note
            eventInformation.idAuction = auction_details.id
            eventInformation.idRfq = ''
            eventInformation.eventOpeningPrice = auction_details.opening_price
            eventInformation.eventReservePrice = auction_details.reserve_price
            eventInformation.is_bid = auction_details.is_min_bid_used
            eventInformation.bid_decrement =
              auction_details.bid_decrement_increment
            eventInformation.bid_minimum =
              auction_details.min_bid_decrement_increment
            eventInformation.is_ExtensionTime =
              auction_details.is_extension_time_used
            eventInformation.eventExtensionMinutes =
              auction_details.extension_minutes
            eventInformation.is_MaxExtension = auction_details.extension_time
              ? true
              : false
            eventInformation.eventExtensionTime = auction_details.extension_time
            eventInformation.is_HideLeadingBidAmount =
              auction_details.use_hide_leading_bid_reserve
            eventInformation.eventHideLeadingBidTime =
              auction_details.hide_leading_bid_time_before_close
            eventInformation.is_HideLeadingBidTime = auction_details.hide_leading_bid_time_before_close
              ? true
              : false
            eventInformation.is_BidType = auction_details.bidding_type_id
            eventInformation.is_display_dummy =
              auction_details.display_dummy_supplier_name
            const mapArrayFiles = this.funcMapFilesStatus(filesRfq)
            eventInformation.internalFile = mapArrayFiles
            eventInformation.eventId = auction_details.event_id
          }
          // console.log('formData', formData)
          if (this._isMounted) {
            this.setState({
              formData,
              isErrProductName: false,
              isErrProductQty: false,
              isErrProductUOM: false,
              isErrProductBuget: false,
              isLoader: false,
            })
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
  onClickSaveDraft = async e => {
    await this.setState({ isLoader: true })
    const { match } = this.props
    const { id, idProject, eventid } = match.params
    const projectId = idProject || id
    let { formData, activeStep } = this.state
    const { history } = this.props
    const { step1, step2 } = formData
    const isFrom = localStorage.getItem('isFromDetail')

    const historyBrowser = (pathLink, id, event_id) => {
      const historyBrowser = createBrowserHistory({
        basename: pathLink,
        forceRefresh: false,
      })
      historyBrowser.push(`/${id}/${event_id}`)
    }

    const controFuncStep1 = async () => {
      if (activeStep === 0) {
        const saveDraft = this.validateSaveDraft()
        if (saveDraft) {
          try {
            const parameter = this.setDataSendApi()
            // const res = await rfqController().createSourcingProject(parameter)
            const res = await eventNewController().createProject(parameter)
            if (res) {
              const { id, rfq_details, auction_details } = res
              toastActive('Save the changes successfully')
              const event_id =
                (rfq_details && rfq_details.event_id) ||
                (auction_details && auction_details.event_id)
              const details_id =
                (rfq_details && rfq_details.id) ||
                (auction_details && auction_details.id)
              if (rfq_details || auction_details) {
                this.funcFetchCreateProjectStep(id, event_id)
              } else {
                this.funcFetchCreateProjectStep(id)
              }

              this.setState({ isLoading: false, isLoader: false })
              if (
                this.props.location &&
                this.props.location.pathname.includes(
                  '/sourcing-detail-form-buyer-cocr'
                )
              ) {
                if (isFrom === 'true') {
                  return history.push(
                    `/sourcing-detail-form-buyer-cocr-edit/${id}/${event_id}`
                  )
                } else {
                  return history.push(
                    `/sourcing-detail-form-buyer/${id}/${event_id}`
                  )
                }
              } else if (projectId && eventid) {
                return history.push(
                  `/sourcing-detail-form-buyer/${id}/${event_id}`
                )
              } else if (projectId && !eventid) {
                return history.push(`/sourcing-detail-form-buyer/${id}`)
              } else {
                return history.push(`/sourcing-detail-form-buyer/${id}`)
              }
            }
          } catch (error) {
            console.log('error', error)
            toastFail('Error')
            this.setState({ isLoading: false, isLoader: false })
          }
        }
      }
    }
    const controFuncStep2 = async () => {
      if (activeStep === 1) {
        const saveDraft = this.validateSaveDraft()
        if (saveDraft) {
          const parameter = this.setDataSendApi()
          try {
            const res = await eventNewController().createProject(parameter)
            // const res = await rfqController().createProjectAndEvent(parameter)
            const { rfq_details, auction_details, id } = res
            if (res) {
              this.setState({ isLoading: false })
              toastActive('Save the changes successfully')
              const pathArray = this.props.location.pathname
              const pathLink = pathArray.split('/')
              const event_id =
                (rfq_details && rfq_details.event_id) ||
                (auction_details && auction_details.event_id)
              const details_id =
                (rfq_details && rfq_details.id) ||
                (auction_details && auction_details.id)

              this.funcFetchCreateProjectStep(id, event_id)
              if (rfq_details) {
                formData.step2.eventInformation.idRfq = details_id
                formData.step2.eventInformation.idAuction = ''
              }
              if (auction_details) {
                formData.step2.eventInformation.idAuction = details_id
                formData.step2.eventInformation.idRfq = ''
              }

              if (
                this.props.location &&
                this.props.location.pathname.includes(
                  '/sourcing-detail-form-buyer-cocr'
                )
              ) {
                if (isFrom === 'true') {
                  return historyBrowser(
                    '/sourcing-detail-form-buyer-cocr-edit',
                    id,
                    event_id
                  )
                } else {
                  return historyBrowser(
                    '/sourcing-detail-form-buyer',
                    id,
                    event_id
                  )
                }
              } else if (pathLink && pathLink.length > 0 && !eventid) {
                // fix save draft reload page
                // return history.push(`/${pathLink[1]}/${id}/${event_id}`)
                return historyBrowser(pathLink[1], id, event_id)
              }
            }
          } catch (error) {
            // console.log({ error })
            this.setState({ isLoading: false, isLoader: false })
            toastFail('Error')
          }
        }
      }
    }
    const controFuncStep3 = async () => {
      if (activeStep === 2) {
        const saveDraft = this.validateSaveDraft()
        if (saveDraft) {
          const parameter = this.setDataSendApi()
          try {
            const res = await eventNewController().createProject(parameter)
            // const res = await rfqController().createProjectAndEvent(parameter)
            if (res) {
              const pathArray = this.props.location.pathname
              const pathLink = pathArray.split('/')
              const { rfq_details, auction_details, id } = res
              toastActive('Save the changes successfully')
              this.setState({ isLoading: false })
              const event_id =
                (rfq_details && rfq_details.event_id) ||
                (auction_details && auction_details.event_id)
              const details_id =
                (rfq_details && rfq_details.id) ||
                (auction_details && auction_details.id)

              this.funcFetchCreateProjectStep(id, event_id)
              if (rfq_details) {
                formData.step2.eventInformation.idRfq = details_id
                formData.step2.eventInformation.idAuction = ''
              }
              if (auction_details) {
                formData.step2.eventInformation.idAuction = details_id
                formData.step2.eventInformation.idRfq = ''
              }
              if (
                this.props.location &&
                this.props.location.pathname.includes(
                  '/sourcing-detail-form-buyer-cocr'
                )
              ) {
                if (isFrom === 'true') {
                  return historyBrowser(
                    '/sourcing-detail-form-buyer-cocr-edit',
                    id,
                    event_id
                  )
                } else {
                  return historyBrowser(
                    '/sourcing-detail-form-buyer',
                    id,
                    event_id
                  )
                }
              } else if (pathLink && pathLink.length > 0 && !eventid) {
                // fix save draft reload page
                return historyBrowser(pathLink[1], id, event_id)
              }
            }
          } catch (error) {
            console.log('error', error)
            toastFail('Error')
            this.setState({ isLoading: false, isLoader: false })
          }
        }
      }
    }
    const controFuncStep4 = async () => {
      if (activeStep === 3) {
        const saveDraft = this.validateSaveDraft()
        if (saveDraft) {
          const parameter = this.setDataSendApi()
          try {
            const res = await eventNewController().createProject(parameter)
            // const res = await rfqController().createProjectAndEvent(parameter)
            const { rfq_details, auction_details, id } = res
            // const { event_id, id: idRfq } = auction_details
            if (res) {
              toastActive('Save the changes successfully')
              this.setState({ isLoading: false, isLoader: false })
              const pathArray = this.props.location.pathname
              const pathLink = pathArray.split('/')
              const event_id =
                (rfq_details && rfq_details.event_id) ||
                (auction_details && auction_details.event_id)
              const details_id =
                (rfq_details && rfq_details.id) ||
                (auction_details && auction_details.id)

              this.funcFetchCreateProjectStep(id, event_id)
              if (rfq_details) {
                formData.step2.eventInformation.idRfq = details_id
                formData.step2.eventInformation.idAuction = ''
              }
              if (auction_details) {
                formData.step2.eventInformation.idAuction = details_id
                formData.step2.eventInformation.idRfq = ''
              }

              if (
                this.props.location &&
                this.props.location.pathname.includes(
                  '/sourcing-detail-form-buyer-cocr'
                )
              ) {
                if (isFrom === 'true') {
                  return historyBrowser(
                    '/sourcing-detail-form-buyer-cocr-edit',
                    id,
                    event_id
                  )
                } else {
                  return historyBrowser(
                    '/sourcing-detail-form-buyer',
                    id,
                    event_id
                  )
                }
              } else if (pathLink && pathLink.length > 0 && !eventid) {
                // fix save draft reload page
                return historyBrowser(pathLink[1], id, event_id)
              }
            }
          } catch (error) {
            toastFail('Error')
            this.setState({ isLoading: false, isLoader: false })
          }
        }
      }
    }
    try {
      controFuncStep1()
      controFuncStep2()
      controFuncStep3()
      controFuncStep4()
    } catch (error) {
      console.log(error)
    }
  }

  updateSupplierSubmit = async id => {
    this.setState({ isLoading: true })
    let { selectSuppliersRfq } = this.state
    let params = {}
    params.rfq_supplier = []
    params.rfq_id = id
    params.rfq_status_id = 2
    selectSuppliersRfq.map((e, i) => {
      const supplier = {}
      supplier.supplier_id = e.SupplierID
      params.rfq_supplier.push(supplier)
    })

    const supplier = await rfqController().updateRFQSupplier(params)
    if (supplier) {
      if (this._isMounted) {
        this.setState({ selectSuppliersRfq, isLoading: false })
      }
    } else {
      if (this._isMounted) {
        this.setState({ isLoading: false })
      }
      toastFail('error updateSupplier')
    }

    await this.uploadFileInternal(id)
  }

  isValidateSubmit = async () => {
    if (this.state.isLoading) {
      return
    }

    let { formData, selectSuppliersRfq, activeStep } = this.state
    const filterSup = filter(selectSuppliersRfq, value => value !== undefined)
    const { step1, step2 } = formData
    const { sourcingProject } = step1
    const { eventInformation } = step2
    if (this.validateSubmit()) {
      formData.rfq_status_id = 2
      eventInformation.auction_status_id = 2
      let paramsValid = {}
      paramsValid.rfq_supplier = []
      const newOptions = []
      sourcingProject.purchasing_company_web.map(e => {
        const options = {
          purchasing_company_id: parseInt(e.value),
        }
        newOptions.push(options)
      })
      formData.purchasing_company = newOptions
      paramsValid.purchasing_company = newOptions
      map(filterSup, e => {
        const supplier = {
          supplier_id: e.SupplierID,
        }
        paramsValid.rfq_supplier.push(supplier)
      })
      const valid = await rfqController().validSubmit(paramsValid)
      if (valid) {
        if (valid.status === 'success') {
          this.toggleModal('confirm-submit'),
            document.body.classList.remove('modal-open')
        } else {
          valid.valid.map(e => {
            toastFail(e)
            if (e === 'Purchasing Company Inactive') {
              this.getMaster.getPurchasingCompany()

              activeStep = 0
            }
            if (this._isMounted) {
              this.setState({ activeStep, isSubmit: false })
            }
          })
        }
      }
    } else {
      if (this._isMounted) {
        this.setState({ isSubmit: false })
      }
    }
  }
  onSubmit = async () => {
    this.setState({ isLoading: true })
    const {
      formData,
      clicks,
      products,
      selectSuppliersRfq,
      internalFile,
      externalFile,
    } = this.state
    const { history } = this.props
    const parameter = this.setDataSendApi()
    try {
      // const res = await rfqController().createProjectAndEvent(parameter)
      const res = await eventNewController().createProject(parameter)
      if (res) {
        if (res === '52017: sourcing project was completed') {
          throw res
        } else {
          if (this._isMounted) {
            this.setState({
              isLoading: false,
              isSubmit: false,
              clicks: 0,
            })
          }
          if (parameter.event.event_type_id === 2) {
            toastActive('Auction is created sucessfully')
          }
          if (parameter.event.event_type_id === 1) {
            toastActive('RFQ is created sucessfully')
          }
          return history.push(ROUTE_PATH.SOURCING_PROJECTS.LINK)
        }
      }
    } catch (error) {
      toastFail('error')
    }
    if (clicks == 1) {
      const res = await rfqController().createProjectAndEvent(parameter)
      try {
        if (res) {
          if (res === '52017: sourcing project was completed') {
            throw res
          } else {
            if (this._isMounted) {
              this.setState({
                isSubmit: true,
                isLoading: false,
                isErrMsgStartDate: '',
                isErrStartDate: false,
              })
            }
            if (parameter.event.event_type_id === 2) {
              toastActive('Auction is created sucessfully')
            }
            if (parameter.event.event_type_id === 1) {
              toastActive('RFQ is created sucessfully')
            }
            return history.push(ROUTE_PATH.SOURCING_PROJECTS.LINK)
          }
        } else {
          if (this._isMounted) {
            this.setState({
              isLoading: false,
              isSubmit: false,
              clicks: 0,
            })
          }
          toastFail('error')
        }
      } catch (error) {
        if (this._isMounted) {
          this.setState({
            isLoading: false,
            isSubmit: false,
            clicks: 0,
          })
        }
        console.log(error)
      }
    }
  }
  addProduct = () => {
    const { formProduct, formData, products } = this.state

    if (this.validateProduct()) {
      if (products.items) {
        products.items.push(formProduct)
      } else {
        products.items = []
        products.items.push(formProduct)
      }

      document.getElementById('budget_price').value = null
      document.getElementById('historical_price').value = null
      document.getElementById('market_price').value = null
      document.getElementById('uom_id').value = null
      if (this._isMounted) {
        this.setState({
          formProduct: {
            budget_price: null,
            description: '',
            historical_price: null,
            market_price: null,
            name: '',
            req_amount: '',
            uom_id: null,
            rfq_buyer_item_file: [],
            auction_buyer_item_file: [],
          },
          formData,
        })
      }
    }
  }

  editProduct = () => {
    const { formProduct, products, indexProductEdit } = this.state
    if (this.validateProduct()) {
      document.getElementById('budget_price').value = null
      document.getElementById('historical_price').value = null
      document.getElementById('market_price').value = null
      document.getElementById('uom_id').value = null
      products.items[indexProductEdit] = formProduct
      if (this._isMounted) {
        this.setState({
          isEditProduct: false,
          indexProductEdit: null,
          formProduct: {
            budget_price: null,
            description: '',
            historical_price: null,
            market_price: null,
            name: '',
            req_amount: '',
            uom_id: null,
            rfq_buyer_item_file: [],
            auction_buyer_item_file: [],
          },
          products,
        })
      }
    }
  }

  // On file select (from the pop up)
  readUploadFile = async event => {
    // Update the state
    this.setState({ uploadFail: false, isLoading: true })
    const value = event.target.files[0]
    var res = value.name.substr(value.name.lastIndexOf('.')) === '.xlsx'
    if (res) {
      let formData = new FormData()
      formData.append('file', value)
      return eventNewController()
        .uploadProductItem(formData)
        .then(res => {
          if (res) {
            let errmsg
            if (res.includes('53009: ')) {
              errmsg = res.split('53009: ')
              toastFail(errmsg[1])
              this.setState({ isLoading: false })
            } else if (res.includes('53010')) {
              errmsg = res.split('53010: ')
              toastFail(errmsg[1])
              this.setState({ isLoading: false })
            } else if (res.includes('53011')) {
              errmsg = res.split('53011: ')
              toastFail(errmsg[1])
              this.setState({ isLoading: false })
            } else if (res.includes('53012')) {
              errmsg = res.split('53012: ')
              toastFail(errmsg[1])
              this.setState({ isLoading: false })
            } else {
              this.setState({
                selectedFile: null,
                isLoading: false,
                products: {
                  items: res,
                },
              })
              toastActive('Upload successfully')
              this.validateActiveStep()
            }
          }
        })
        .catch(err => {
          this.setState({ isLoading: false, uploadFail: true })
          throw err
        })
    } else {
      this.setState({ isLoading: false })
      toastFail('Incorrect file format')
    }
  }

  validateDataUpload = res => {
    const validatePass = {
      pass: true,
      require: [],
      less: [],
    }
    const row = 3
    res.map(r => {
      if (r.name == '') {
        validatePass.pass = false
        validatePass.require.push('B' + row)
      }
      if (r.req_amount <= 0) {
        validatePass.pass = false
        validatePass.less.push('D' + row)
      }
      if ((r.uom == '') | (r.uom_id == '')) {
        validatePass.pass = false
        validatePass.require.push('E' + row)
      }
      if (r.budget_price <= 0) {
        validatePass.pass = false
        validatePass.less.push('F' + row)
      }
    })
    return validatePass
  }

  onClickTemplateLink = e => {
    const { eventInformation } = this.state.formData.step2
    if (e.detail === 1) {
      return this._downloadTemplateLink(
        eventInformation.eventId || eventInformation.eventIdForDownload,
        eventInformation.currency_id
      )
    }
  }

  _downloadTemplateLink = (id, currency_id) => {
    this.setState({ isLoading: true })
    return eventNewController()
      .downloadProductItem(id, currency_id)
      .then(res => {
        this.setState({ isLoading: false })
        FileDownload(
          res.data,
          'Item_Buyer_Template_' + Moment().format('DDMMyyyy_hhmm') + '.xlsx'
        )
      })
      .catch(err => {
        this.setState({ isLoading: false })
        throw err
      })
  }

  uploadItemFile = async event => {
    const { formProduct } = this.state
    let { loadingFileStep2 } = this.state
    const eventType = this.state.formData.step2.eventInformation.eventType
    const formData = new FormData()
    loadingFileStep2 = true
    this.setState({ loadingFileStep2 })
    try {
      this.setState({ isUpload: true })
      formData.append('file', event)
      let res = await eventNewController().uploadEventItemFile(formData)

      if (res) {
        if (res === '4010: File contains code') {
          toast.error('Wrong file format.')
          this.setState({
            loadingFileStep2: false,
          })
        } else {
          const file = {
            name: res.name,
            id: res.id,
            event_item_id: res.event_item_id,
            is_deleted: false,
          }
          console.log
          let newFormProduct = { ...formProduct }
          if (eventType === 1) {
            let new_rfq_buyer_item_file = newFormProduct.event_item_file
              ? [...newFormProduct.event_item_file]
              : []
            new_rfq_buyer_item_file.push(file)
            newFormProduct.event_item_file = new_rfq_buyer_item_file
            if (this._isMounted) {
              loadingFileStep2 = false
              this.setState({ formProduct: newFormProduct, loadingFileStep2 })
            }
          }
          if (eventType === 2) {
            let new_auction_buyer_item_file = newFormProduct.event_item_file
              ? [...newFormProduct.event_item_file]
              : []
            new_auction_buyer_item_file.push(file)
            newFormProduct.event_item_file = new_auction_buyer_item_file
            if (this._isMounted) {
              loadingFileStep2 = false
              this.setState({ formProduct: newFormProduct, loadingFileStep2 })
            }
          }
          this.setState({ isUpload: false })
        }
      } else {
        // toastFail('try again')
        toastFail('Failed to upload file, please try again.')
      }
    } catch (err) {
      console.log(err)
    }
    this.setState({ isUpload: false })
    this.setState({ loadingFileStep2: false })
  }

  onChangeFileInternal = async (file, activeStep = 0) => {
    // console.log('data file up', file)
    const { internalFile, formData: addFormData } = this.state
    // const { eventType } = addFormData.step2.eventInformation
    if (file) {
      // let file = event
      let size = 50000000
      if (this._isMounted) {
        this.setState({ loadingFileInternal: true })
      }
      if (file) {
        const isFilesType = await checkFileType(file)
        if (isFilesType) {
          if (file.size > size) {
            toastFail('File size exceeded 50 Mb')
            if (this._isMounted) {
              this.setState({ loadingFileInternal: false })
            }
          } else {
            const formData = new FormData()
            formData.append('name', file.name)
            formData.append('file', file)
            const funcUploadFile = async () => {
              let res = ''
              console.log(activeStep)
              switch (activeStep) {
                case 0: {
                  console.log('case 0')
                  res = await rfqController().uploadFileSourcingProject(
                    formData
                  )
                  return res
                }
                case 1: {
                  console.log('case 1')
                  res = await eventNewController().uploadInternalFile(formData)
                  return res
                }
                case 2: {
                  console.log('case 2')
                  res = await eventNewController().uploadInternalFile(formData)
                  return res
                }
                case 3: {
                  console.log('case 3')
                  res = await eventNewController().uploadInternalFile(formData)
                  return res
                }
                default:
                  break
              }
            }
            const controStep1 = res => {
              switch (activeStep) {
                case 0:
                  {
                    if (res) {
                      if (this._isMounted) {
                        const { id, file_name } = res
                        const resFiles = [{ id, file_name, is_deleted: false }]
                        const { step1 } = addFormData
                        const { sourcingProject } = step1
                        const pushArray = [
                          ...addFormData.sourcing_project_attachment_files_request,
                          ...resFiles,
                        ]
                        addFormData.sourcing_project_attachment_files_request = pushArray
                        this.setState({
                          loadingFileInternal: false,
                          formData: addFormData,
                        })
                      }
                    }
                  }
                  break
                default:
                  break
              }
            }
            const controStep2 = res => {
              switch (activeStep) {
                case 1:
                  {
                    if (this._isMounted) {
                      const { id, name } = res
                      const resFiles = [{ id, name, is_deleted: false }]
                      const { step2 } = addFormData
                      const { eventInformation } = step2
                      const pushArray = [
                        ...eventInformation.internalFile,
                        ...resFiles,
                      ]
                      eventInformation.internalFile = pushArray
                      this.setState({
                        loadingFileInternal: false,
                        formData: addFormData,
                      })
                    }
                  }
                  break
                default:
                  break
              }
            }
            try {
              const res = await funcUploadFile()
              if (res === '4010: File contains code') {
                toast.error('Wrong file format.')
                this.setState({
                  loadingFileInternal: false,
                })
              } else {
                if (res.id && (res.name || res.file_name)) {
                  // if (res.file_name) {
                  //   res.name = res.file_name
                  // }
                  controStep1(res)
                  controStep2(res)
                } else {
                  toastFail('Failed to upload file, please try again.')
                  this.setState({
                    loadingFileInternal: false,
                  })
                }
              }
            } catch (error) {
              // if (this._isMounted) {
              this.setState({ loadingFileInternal: false })
              // }
              // return toastFail('try again')
            }
          }
        } else {
          if (this._isMounted) {
            this.setState({ loadingFileInternal: false })
          }
        }
      }
    }
  }

  onChangeFileExternal = async event => {
    const { externalFile } = this.state
    const eventType = this.state.formData.step2.eventInformation.eventType
    this.setState({ loadingFileStep3: true })
    if (event) {
      let files = event
      let size = 50000000
      if (files) {
        const isFilesType = await checkFileType(files)
        if (isFilesType) {
          if (files.size > size) {
            toastFail('File size exceeded 50 Mb')
            if (this._isMounted) {
              this.setState({ loadingFileStep3: false })
            }
          } else {
            const formData = new FormData()
            formData.append('name', files.name)
            formData.append('file', files)
            try {
              let res = await eventNewController().uploadExternalFile(formData)
              if (res) {
                if (res === '4010: File contains code') {
                  toast.error('Wrong file format.')
                } else if (res.name && res.id) {
                  const resFiles = {
                    name: res.name,
                    id: res.id,
                    is_deleted: false,
                  }
                  externalFile.push(resFiles)
                  if (this._isMounted) {
                    this.setState({ externalFile })
                  }
                } else {
                  toastFail('Failed to upload file, please try again.')
                }
              }
            } catch (e) {
              // console.log(e)
            }
          }
        }
      }
    }
    this.setState({ loadingFileStep3: false })
  }

  downloadExternal = params => {
    return eventNewController()
      .downloadExternal(params.id)
      .then(res => {
        this.deleteLoadingDownloadFile(params)
        FileDownload(res.data, params.name)
      })
  }

  downloadInternal = async (id, name, activeStep) => {
    // const eventType = this.state.formData.step2.eventInformation.eventType
    let res = ''
    switch (activeStep) {
      case 0: {
        return rfqController()
          .downloadFileSourcingProject(id)
          .then(res => {
            console.log('response file', res)
            this.deleteLoadingDownloadFile({ id: id })
            FileDownload(res.data, name)
          })
      }
      // case 0: {
      //   res = await rfqController().downloadFileSourcingProject(id)
      //   console.log('response file', res)
      //   return res
      // }
      case 1: {
        return eventNewController()
          .downloadInternal(id)
          .then(res => {
            this.deleteLoadingDownloadFile({ id: id })
            FileDownload(res.data, name)
          })
      }
      // case 1: {
      //   res = await eventNewController().downloadInternal(id)
      //   console.log('response file', res)
      //   return res
      // }
      case 2: {
        return ''
      }
      case 3: {
        return ''
      }
      default:
        break
    }
  }

  downloadItem = params => {
    return eventNewController()
      .downloadEventItemFile(params.id)
      .then(res => {
        this.deleteLoadingDownloadFile(params)
        FileDownload(res.data, params.name)
      })
  }
  handlerChangeAttachFile = e => {
    const { activeStep } = this.state
    return this.onChangeFileInternal(e, activeStep)
  }

  setLoadingDownloadFile = file => {
    this.state.loadingDownloadFile.push({ id: file.id })
    this.setState({
      loadingDownloadFile: this.state.loadingDownloadFile,
    })
  }

  deleteLoadingDownloadFile = file => {
    let index = this.state.loadingDownloadFile.findIndex(x => x.id === file.id)
    this.state.loadingDownloadFile.splice(index, 1)
    this.setState({
      loadingDownloadFile: this.state.loadingDownloadFile,
    })
  }

  renderDownloadFile = file => {
    return (
      this.state.loadingDownloadFile &&
      this.state.loadingDownloadFile.map((value, index) => {
        if (value.id === file.id) {
          return (
            <Loaders
              load={true}
              key={index}
              style={{
                marginLeft: '-35px',
                position: 'relative',
                right: '-75px',
              }}
            />
          )
        }
      })
    )
  }

  step1Content() {
    const {
      formData,
      businessCategory,
      currency,
      purchasingCompany,
      purchasingTypes,
      isErrName,
      isErrCategory,
      isErrPurchasingType,
      isErrProjectReference,
      isErrCompanyCode,
      isErrCurrency,
      irErrVat,
      isErrEstimateBudget,
      isErrTargetSaving,
      isErrTargetDate,
      internalFile,
      isErrMsgTargetDate,
      isErrMsgEstimateBudget,
    } = this.state
    const handleTofuChange = nextChecked => {
      formData.seal_type = nextChecked
      if (this._isMounted) {
        return this.setState({ formData })
      }
    }
    const renderTextSeal = () => {
      if (formData.seal_type) {
        return 'Sealed'
      } else {
        return ''
      }
    }
    const renderSelectPredecessor = () => {
      const { optionsPredecessor, formData } = this.state
      const handleChange = valueSelect => {
        if (this._isMounted) {
          formData.step1.sourcingProject.predecessors = valueSelect
          this.setState({
            formData,
          })
        }
      }
      return (
        <Section className="form-group-control">
          <Section className="form-group-inner-wrapper">
            <SelectBoxPredecessor
              id="predecessor"
              options={optionsPredecessor}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              onChange={handleChange}
              fieldValue={
                formData.step1.sourcingProject.predecessors
                  ? formData.step1.sourcingProject.predecessors
                  : ''
              }
              isDisabled={
                this.state.getCreatenewround || !this.state.editRoleDetail
                  ? true
                  : false
              }
            />
          </Section>
          <Section className="message"></Section>
        </Section>
      )
    }
    const funcRenderAttachmentSourcingProject = () => {
      const handlerClickAttachFile = e => {
        if (e.detail === 1) {
          e.target.value = null
          return e.target.value
        }
      }
      const {
        formData: formDataFileStep1,
        activeStep,
        editRoleDetail,
      } = this.state
      const {
        step1,
        sourcing_project_attachment_files_request,
      } = formDataFileStep1

      const handlerDownloadInternal = file => {
        if (file.id) {
          this.setLoadingDownloadFile(file)
          return this.downloadInternal(file.id, file.file_name, activeStep)
        } else {
          return null
        }
      }

      const onRemoveFile = file => {
        if (file) {
          sourcing_project_attachment_files_request.map(e => {
            if (file.id === e.id) {
              e.is_deleted = true
            }
          })
          formDataFileStep1.sourcing_project_attachment_files_request = sourcing_project_attachment_files_request
          if (this._isMounted) {
            return this.setState(
              { formData: formDataFileStep1 },
              this.forceUpdate()
            )
          }
        }
      }
      // console.log('Internal Attachment 1')
      return (
        <Section className="form-group">
          <label className="tooltip-upload">
            Internal Attachment <br />
            {this.state.getCreatenewround || !this.state.editRoleDetail
              ? null
              : '(Optional)'}
            <Section className="link tooltip-attachment">
              <Image
                src={ICONS['icon-help.svg']}
                alt="help"
                tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                useTootipFor="FileType"
                useTootip={true}
              />
            </Section>
          </label>

          <Section className="form-group-attached-file">
            <AttachedFile
              id="upload-internal-project"
              maxFileSizeMb={50}
              classNameInput={'form-group-attached-file-wrapper'}
              onSelect={(file, e, cb) => {
                console.log('file', file)
                if (file != null) {
                  this.handlerChangeAttachFile(file, cb)
                }
              }}
              isHideIput={true}
              isDisableInput={
                (this.state.activeStep === 0 && this.state.getCreatenewround) ||
                !this.state.editRoleDetail
                  ? true
                  : false
              }
              isIcon={true}
              hasRemove={
                this.state.activeStep === 0 && this.state.getCreatenewround
                  ? false
                  : editRoleDetail
              }
              fileList={sourcing_project_attachment_files_request}
              onDownload={e => handlerDownloadInternal(e)}
              onClickRemove={e => onRemoveFile(e)}
              loadingDownload={this.state.loadingDownloadFile}
            />
            {/* </Section> */}
            {/* {renderInternalFile()} */}
          </Section>
        </Section>
      )
    }
    return (
      <Section className="form-wrapper">
        <Section className="form-group-header">Project Information</Section>
        <Section className="form-row">
          <Section className="form-col col-6">
            <Section className={`form-group`}>
              <label>Project No.</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Input
                    type="text"
                    value={
                      formData.step1.sourcingProject.project_no
                        ? formData.step1.sourcingProject.project_no
                        : ''
                    }
                    readOnly
                  />
                </Section>
                <Section className="message">
                  {isErrName && STRING.INVALID}
                </Section>
              </Section>
            </Section>
          </Section>
          <Section className="form-col col-6">
            <Section className={`form-group`}>
              <label>Project Status</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Input
                    type="text"
                    value={
                      formData.step1.sourcingProject.project_status_name
                        ? formData.step1.sourcingProject.project_status_name
                        : ''
                    }
                    readOnly
                  />
                </Section>
                <Section className="message">
                  {isErrName && STRING.INVALID}
                </Section>
              </Section>
            </Section>
          </Section>
        </Section>

        <Section className="form-row">
          <Section className="form-col col-6">
            <Section className={`form-group ${isErrName && 'is-error'}`}>
              <label>Project Name</label>

              <Section className="form-group-control">
                <Section
                  className="form-group-inner-wrapper"
                  onBlur={() => {
                    formData.step1.sourcingProject.name = formData.step1.sourcingProject.name.trimEnd()
                    if (this._isMounted) {
                      this.setState({
                        formData,
                      })
                    }
                  }}
                >
                  <Input
                    type="text"
                    value={
                      formData.step1.sourcingProject.name
                        ? formData.step1.sourcingProject.name
                        : ''
                    }
                    maxLength="80"
                    onChange={e => {
                      formData.step1.sourcingProject.name = e.target.value.trimStart()
                      if (this._isMounted) {
                        this.setState({
                          formData,
                          isErrName: false,
                        })
                      }
                    }}
                    readOnly={
                      this.state.getCreatenewround || !this.state.editRoleDetail
                        ? true
                        : false
                    }
                  />
                </Section>

                <Section className="message">
                  {isErrName && STRING.INVALID}
                </Section>
              </Section>
            </Section>
          </Section>
          <Section className="form-col col-6">
            <Section className={`form-group`}>
              <label>Create Date</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Input
                    type="text"
                    value={
                      formData.step1.sourcingProject.createDate
                        ? formData.step1.sourcingProject.createDate
                        : ''
                    }
                    readOnly
                  />
                </Section>

                <Section className="message">
                  {isErrName && STRING.INVALID}
                </Section>
              </Section>
            </Section>
          </Section>
        </Section>

        <Section className="form-row">
          <Section className="form-col col-6">
            <Section className="form-group">
              <label>
                Description <br /> (Optional)
              </label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <InputTextarea
                    className="input-description"
                    value={
                      formData.step1.sourcingProject.description
                        ? formData.step1.sourcingProject.description
                        : ''
                    }
                    onChange={e => {
                      formData.step1.sourcingProject.description =
                        e.target.value
                      if (this._isMounted) {
                        this.setState({
                          formData,
                        })
                      }
                    }}
                    readOnly={
                      this.state.getCreatenewround || !this.state.editRoleDetail
                        ? true
                        : false
                    }
                  />
                </Section>

                <Section className="message"></Section>
              </Section>
            </Section>
          </Section>
          <Section className="form-col col-6">
            <Section
              className={`form-group ${isErrEstimateBudget && 'is-error'}`}
            >
              <label>Estimate Budget ({this.state.baseCurrency})</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <NumberFormat
                    value={
                      formData.step1.sourcingProject.estimate_budget &&
                      Math.max(
                        0,
                        formData.step1.sourcingProject.estimate_budget
                      )
                    }
                    customInput={Input}
                    decimalScale={2}
                    maxLength={18}
                    placeholder="0.00"
                    onChange={e => {
                      if (!e.target.value) {
                        formData.step1.sourcingProject.estimate_budget = null
                      } else {
                        formData.step1.sourcingProject.estimate_budget = parseFloat(
                          Numeral(e.target.value).format('0.00')
                        )
                        this.onChangeBudget(
                          formData.step1.sourcingProject.estimate_budget
                        )
                      }
                      if (this._isMounted) {
                        this.setState({
                          formData,
                          isErrEstimateBudget: false,
                        })
                      }
                    }}
                    thousandSeparator={true}
                    readOnly={
                      this.state.getCreatenewround || !this.state.editRoleDetail
                        ? true
                        : false
                    }
                  />
                </Section>

                <Section className="message">
                  {isErrEstimateBudget && isErrMsgEstimateBudget
                    ? isErrMsgEstimateBudget
                    : isErrEstimateBudget && !isErrMsgEstimateBudget
                    ? STRING.INVALID
                    : ''}
                </Section>
              </Section>
            </Section>
            <Section
              className={`form-group ${isErrTargetSaving && 'is-error'}`}
            >
              <label>
                Target Saving (%) <br />
                {this.state.getCreatenewround || !this.state.editRoleDetail
                  ? null
                  : '(Optional)'}
              </label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <NumberFormat
                    type="text"
                    value={
                      formData.step1.sourcingProject.target_saving
                        ? formData.step1.sourcingProject.target_saving
                        : ''
                    }
                    isAllowed={inputObj => {
                      const { value } = inputObj
                      if (value !== '-') return true
                      return false
                    }}
                    placeholder="0"
                    customInput={Input}
                    decimalScale={0}
                    maxLength={3}
                    onChange={e => {
                      if (Number(e.target.value) <= 100) {
                        formData.step1.sourcingProject.target_saving = Number(
                          e.target.value
                        )
                        this.setState({
                          isErrTargetSaving: false,
                        })
                      } else {
                        formData.step1.sourcingProject.target_saving = 0
                        this.setState({
                          isErrTargetSaving: true,
                        })
                      }

                      if (this._isMounted) {
                        this.setState({
                          formData,
                        })
                      }
                    }}
                    thousandSeparator={true}
                    readOnly={
                      this.state.getCreatenewround || !this.state.editRoleDetail
                        ? true
                        : false
                    }
                  />
                </Section>

                <Section className="message">
                  {isErrTargetSaving && ' Please fill in between 1 to 100'}
                </Section>
              </Section>
            </Section>
          </Section>
        </Section>

        <Section className="form-row">
          <Section className="form-col col-6">
            <Section className={`form-group ${isErrCategory && 'is-error'}`}>
              <label>Category</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <SelectBox
                    id="active_category_filter"
                    style={{ zIndex: '55' }}
                    options={businessCategory}
                    placeholder="Select Category"
                    value={
                      formData.step1.sourcingProject.categories
                        ? formData.step1.sourcingProject.categories
                        : ''
                    }
                    onChange={event => {
                      formData.step1.sourcingProject.categories = event
                      if (this._isMounted) {
                        this.setState({
                          formData,
                          isErrCategory: false,
                        })
                      }
                    }}
                    isDisabled={
                      this.state.getCreatenewround || !this.state.editRoleDetail
                        ? true
                        : false
                    }
                  />
                </Section>

                <Section className="message">
                  {isErrCategory && STRING.INVALID}
                </Section>
              </Section>
            </Section>
          </Section>
          <Section className="form-col col-6">
            <Section className={`form-group ${isErrTargetDate && 'is-error'}`}>
              <label>Target Date</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <DatePickerInput
                    selected={
                      formData.step1.sourcingProject.target_date
                        ? formData.step1.sourcingProject.target_date
                        : null
                    }
                    onChange={date => {
                      formData.step1.sourcingProject.target_date = date
                      if (this._isMounted) {
                        this.setState({
                          formData,
                          isErrTargetDate: false,
                        })
                      }
                    }}
                    openToDate={new Date()}
                    selectsStart
                    minDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    dateFormat="MMM d, yyyy"
                    dropdownMode="select"
                    disabled={
                      this.state.getCreatenewround || !this.state.editRoleDetail
                        ? true
                        : false
                    }
                  />
                </Section>

                <Section className="message">
                  {isErrTargetDate && isErrMsgTargetDate
                    ? isErrMsgTargetDate
                    : isErrTargetDate && !isErrMsgTargetDate
                    ? STRING.INVALID
                    : ''}
                </Section>
              </Section>
            </Section>
          </Section>
        </Section>

        <Section className="form-row">
          <Section className="form-col col-6">
            <Section className={`form-group`}>
              <label>
                Predecessor <br />
                {this.state.getCreatenewround || !this.state.editRoleDetail
                  ? null
                  : '(Optional)'}
              </label>
              {renderSelectPredecessor()}
            </Section>
          </Section>
          <Section className="form-col col-6">
            <Section className="form-group">
              <label>Created By</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Input
                    type="text"
                    value={
                      formData.step1.sourcingProject.created_by
                        ? formData.step1.sourcingProject.created_by
                        : !!this.props.user && this.props.user.full_name
                    }
                    onChange={e => {}}
                    readOnly={true}
                  />
                </Section>
                <Section className="message"></Section>
              </Section>
            </Section>
          </Section>
        </Section>

        <Section className="form-row">
          <Section className="form-col col-6">
            <Section className={`form-group`}>
              <label>
                Project Reference <br />
                {this.state.getCreatenewround || !this.state.editRoleDetail
                  ? null
                  : '(Optional)'}
              </label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Input
                    type="text"
                    value={
                      formData.step1.sourcingProject.project_reference
                        ? formData.step1.sourcingProject.project_reference
                        : ''
                    }
                    onChange={e => {
                      formData.step1.sourcingProject.project_reference =
                        e.target.value
                      if (this._isMounted) {
                        this.setState({
                          formData,
                        })
                      }
                    }}
                    readOnly={
                      this.state.getCreatenewround || !this.state.editRoleDetail
                        ? true
                        : false
                    }
                  />
                </Section>

                <Section className="message">
                  {isErrProjectReference && STRING.INVALID}
                </Section>
              </Section>
            </Section>

            <Section className={`form-group ${isErrCompanyCode && 'is-error'}`}>
              <label>Purchasing Site</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <SelectBoxPurchasingSite
                    id="purchasing_site"
                    options={purchasingCompany}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{
                      Option,
                      MultiValue,
                      ValueContainer,
                      AnimatedComponents,
                    }}
                    allowSelectAll={true}
                    onChange={this.handleChangePurchasingSite}
                    fieldValue={
                      formData.step1.sourcingProject.purchasing_company_web
                        ? formData.step1.sourcingProject.purchasing_company_web
                        : ''
                    }
                    isErrCompanyCode={isErrCompanyCode}
                    isDisabled={
                      this.state.getCreatenewround || !this.state.editRoleDetail
                        ? true
                        : false
                    }
                  />
                </Section>
                <Section className="message">
                  {isErrCompanyCode && STRING.INVALID}
                </Section>
              </Section>
            </Section>
          </Section>

          <Section className="form-col col-6">
            <Section className="form-group">
              <label>
                Internal Note <br />
                {this.state.getCreatenewround || !this.state.editRoleDetail
                  ? null
                  : '(Optional)'}
              </label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <InputTextarea
                    className="input-internal-note"
                    value={
                      formData.step1.sourcingProject.internal_note
                        ? formData.step1.sourcingProject.internal_note
                        : ''
                    }
                    onChange={e => {
                      formData.step1.sourcingProject.internal_note =
                        e.target.value
                      if (this._isMounted) {
                        this.setState({
                          formData,
                        })
                      }
                    }}
                    readOnly={
                      this.state.getCreatenewround || !this.state.editRoleDetail
                        ? true
                        : false
                    }
                  />
                </Section>

                <Section className="message"></Section>
              </Section>
            </Section>
          </Section>
        </Section>

        <Section className="form-row">
          <Section className="form-col col-6"></Section>
          <Section className="form-col col-6">
            {funcRenderAttachmentSourcingProject()}
          </Section>
        </Section>
      </Section>
    )
  }

  step2Content() {
    const {
      formData,
      currency,
      baseCurrency,
      baseCurrencyId,
      purchasingTypes,
      irErrVat,
    } = this.state
    const { step2 } = formData
    const { eventInformation } = step2
    let currencyOption = []
    let baseCurrencyOption = [{ value: baseCurrencyId, label: baseCurrency }]
    currencyOption = baseCurrencyOption.concat(currency)

    const handleTofuChange = nextChecked => {
      eventInformation.seal_type = nextChecked
      if (nextChecked) {
        eventInformation.seal_status = 1
      } else {
        eventInformation.seal_status = 0
      }
      if (this._isMounted) {
        return this.setState({ formData })
      }
    }
    const renderTextSeal = () => {
      if (eventInformation.seal_type) {
        return 'Sealed'
      } else {
        return ''
      }
    }
    const renderToggleTypeSeal = () => {
      return (
        <React.Fragment>
          <Section className="form-col col-6">
            <Section className={`form-group`} style={{ marginBottom: '20px' }}>
              <label className="seal-envelope">Seal Envelope</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Toggle
                    handleTofuChange={handleTofuChange}
                    checkedToggle={formData.step2.eventInformation.seal_type}
                    disabled={!this.state.editRoleDetail ? true : false}
                  />
                  <span style={{ marginLeft: '11px' }}>{renderTextSeal()}</span>
                </Section>
              </Section>
            </Section>
          </Section>
        </React.Fragment>
      )
    }
    const renderInternalFileStep2 = () => {
      const { activeStep } = this.state
      const { step2 } = formData
      const { eventInformation } = step2
      const internalFile = eventInformation.internalFile
      if (internalFile) {
        const render = (v, k) => {
          const { id, name, is_deleted } = v
          const handlerOnClick = e => {
            if (e.detail === 1) {
              if (id) {
                // this.setLoadingDownloadFile(v)
                return this.downloadInternal(id, name, activeStep)
              } else {
                return null
              }
            }
          }
          const handlerClickDelete = e => {
            if (e.detail === 1) {
              internalFile[k].is_deleted = true
              if (this._isMounted) {
                this.setState({ formData }, this.forceUpdate())
              }
            }
          }
          if (!is_deleted) {
            return (
              // step2
              <>
                <AttachedFile
                  key={k}
                  id={'attached-file-' + id}
                  isIcon={true}
                  onClick={handlerOnClick}
                  fileName={name}
                  hasRemove={this.state.editRoleDetail}
                  onClickRemove={handlerClickDelete}
                />
                {this.renderDownloadFile(v)}
              </>
            )
          }
        }
        return map(internalFile, render)
      }
    }

    const auctionType = type => {
      let Type = type === 'English' ? 1 : 2
      if (this.state.formData.step2.eventInformation.auctionType === Type) {
        return true
      } else {
        return false
      }
    }
    const clearDataAuction = event => {
      if (event.value == 1) {
        formData.step2.eventInformation.auctionType = 1
        formData.step2.eventInformation.is_display_dummy = false
        formData.step2.eventInformation.eventOpeningPrice = ''
        formData.step2.eventInformation.eventReservePrice = ''
        formData.step2.eventInformation.is_ExtensionTime = false
        formData.step2.eventInformation.eventExtensionMinutes = ''
        formData.step2.eventInformation.eventHideLeadingBidTime = ''
        formData.step2.eventInformation.is_HideLeadingBidAmount = false
        formData.step2.eventInformation.is_MaxExtension = ''
        formData.step2.eventInformation.eventExtensionTime = ''
        formData.step2.eventInformation.bid_decrement = ''
        formData.step2.eventInformation.bid_minimum = ''
        formData.step2.eventInformation.purchasingType = 1
        this.matchValueSelected(this.state.optionsAuctionType, 1)
      } else {
        formData.step2.eventInformation.seal_type = false
      }
      this.setState({
        formData,
        isErrOpeningPrice: false,
        isErrMaxExtensionTime: false,
        isErrExtensionMinutes: false,
        isErrBIDDecrement: false,
        isErrBIDMinimum: false,
      })
    }

    const handlerClickDelete = file => {
      const { formData } = this.state
      const { step2 } = formData
      // if (e.detail === 1) {
      if (step2.eventInformation.internalFile.length > 0) {
        step2.eventInformation.internalFile.map(e => {
          if (file.id === e.id) {
            e.is_deleted = true
          }
        })
      }
      // internalFile[k].is_deleted = false
      if (this._isMounted) {
        this.setState({ formData }, this.forceUpdate())
      }
      // }
    }

    return (
      <Section className="form-wrapper">
        <Section className="form-row">
          <Section className="form-group-header">Event Information</Section>
          <Section className="form-col col-6">
            <Section
              className={`form-group ${
                this.state.isErrEventType && 'is-error'
              }`}
            >
              <label>Event Type</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <SelectBox
                    style={{ zIndex: '2' }}
                    id="active_category_filter"
                    options={this.state.optionsEventType}
                    placeholder="Select Event Type"
                    value={this.matchValueSelected(
                      this.state.optionsEventType,
                      formData.step2.eventInformation.eventType
                    )}
                    onChange={event => {
                      formData.step2.eventInformation.eventType = event.value
                      clearDataAuction(event)
                      this.setState({
                        formData,
                        isErrEventType: false,
                      })
                      // }
                    }}
                    isDisabled={!this.state.editRoleDetail ? true : false}
                  />
                </Section>
                <Section className="message">
                  {this.state.isErrEventType && STRING.INVALID}
                </Section>
              </Section>
            </Section>
          </Section>
          <Section className="form-col col-6">
            <Section
              className={`form-group ${
                this.state.isErrBiddingType && 'is-error'
              }`}
            >
              <label>Bidding Type</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Checkbox
                    id="reverse_bid"
                    value="reverse_bid"
                    type="radio"
                    name="reverse_bid"
                    checked={formData.step2.eventInformation.is_BidType === 1}
                    className="inline"
                    disabled={!this.state.editRoleDetail ? true : false}
                    onChange={e => {
                      formData.step2.eventInformation.is_BidType = 1
                      if (this._isMounted) {
                        this.setState({
                          formData,
                          isErrBIDDecrement: false,
                          isErrBIDMinimum: false,
                        })
                      }
                    }}
                  >
                    <div style={{ width: '105px' }}>Reverse</div>
                  </Checkbox>
                  <Checkbox
                    id="forward_bid"
                    value="forward_bid"
                    type="radio"
                    name="forward_bid"
                    checked={formData.step2.eventInformation.is_BidType === 2}
                    className="inline"
                    disabled={!this.state.editRoleDetail ? true : false}
                    onChange={e => {
                      if (this.state.editRoleDetail) {
                        formData.step2.eventInformation.is_BidType = 2
                        if (this._isMounted) {
                          this.setState({
                            formData,
                            isErrBIDDecrement: false,
                            isErrBIDMinimum: false,
                          })
                        }
                      }
                    }}
                  >
                    Forward
                  </Checkbox>
                </Section>
                <Section className="message">
                  {this.state.isErrBiddingType && STRING.INVALID}
                </Section>
              </Section>
            </Section>
          </Section>
        </Section>
        <Section className="form-row">
          <Section className="form-col col-6">
            <Section
              className={`form-group ${
                this.state.isErrEventName && 'is-error'
              }`}
            >
              <label>Event Name</label>
              <Section className="form-group-control">
                <Section
                  className="form-group-inner-wrapper"
                  onBlur={() => {
                    formData.step2.eventInformation.eventName = formData.step2.eventInformation.eventName.trimEnd()
                    if (this._isMounted) {
                      this.setState({
                        formData,
                      })
                    }
                  }}
                >
                  <Input
                    type="text"
                    maxLength="80"
                    className="input-event-name"
                    value={formData.step2.eventInformation.eventName}
                    onChange={e => {
                      formData.step2.eventInformation.eventName = e.target.value.trimStart()
                      if (this._isMounted) {
                        this.setState({
                          formData,
                          isErrEventName: false,
                        })
                      }
                    }}
                    readOnly={!this.state.editRoleDetail ? true : false}
                  />
                </Section>
                <Section className="message">
                  {this.state.isErrEventName && STRING.INVALID}
                </Section>
              </Section>
            </Section>
          </Section>

          <Section className="form-col col-6">
            <Section className={`form-group ${irErrVat && 'is-error'}`}>
              <label className="vat">VAT</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Checkbox
                    id="exclude_vat"
                    value="excludeVAT"
                    type="radio"
                    name="eventVat"
                    checked={!formData.step2.eventInformation.is_vat}
                    className="inline"
                    disabled={!this.state.editRoleDetail ? true : false}
                    onChange={e => {
                      formData.step2.eventInformation.is_vat = false
                      if (this._isMounted) {
                        this.setState({
                          formData,
                        })
                      }
                    }}
                  >
                    <div className="vat" style={{ width: '105px' }}>
                      Exclude VAT
                    </div>
                  </Checkbox>
                  <Checkbox
                    id="include_vat"
                    value="includeVAT"
                    type="radio"
                    name="eventVat"
                    checked={formData.step2.eventInformation.is_vat}
                    className="inline"
                    disabled={!this.state.editRoleDetail ? true : false}
                    onChange={e => {
                      if (this.state.editRoleDetail) {
                        formData.step2.eventInformation.is_vat = true
                        if (this._isMounted) {
                          this.setState({
                            formData,
                          })
                        }
                      }
                    }}
                  >
                    <label className="vat">Include VAT</label>
                  </Checkbox>
                </Section>
                <Section className="message">
                  {irErrVat && STRING.INVALID}
                </Section>
              </Section>
            </Section>
          </Section>
        </Section>

        <Section className="form-row">
          <Section className="form-col col-6">
            <Section className="form-group">
              <label className="description">
                Description <br /> (Optional)
              </label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <InputTextarea
                    className="input-description"
                    value={formData.step2.eventInformation.description}
                    onChange={e => {
                      formData.step2.eventInformation.description =
                        e.target.value
                      if (this._isMounted) {
                        this.setState({
                          formData,
                        })
                      }
                    }}
                    readOnly={!this.state.editRoleDetail ? true : false}
                  />
                </Section>
                <Section className="message"></Section>
              </Section>
            </Section>
          </Section>
          <Section className="form-col col-6">
            <Section className={`form-group`}>
              <label className="currency">Currency</label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <SelectBox
                    id="active_currency_filter"
                    options={currencyOption}
                    placeholder="Select"
                    value={
                      formData.step2.eventInformation.currency_id
                        ? this.matchValueSelected(
                            currencyOption,
                            formData.step2.eventInformation.currency_id
                          )
                        : currencyOption[0]
                    }
                    onChange={event => {
                      formData.step2.eventInformation.currency_id = event.value
                      if (this._isMounted) {
                        this.setState({
                          formData,
                        })
                      }
                    }}
                    isDisabled={!this.state.editRoleDetail ? true : false}
                  />
                </Section>
                <Section className="message"></Section>
              </Section>
            </Section>
            {this.state.formData.step2.eventInformation.eventType === 1 ? (
              <>
                {/* purchasing type  */}
                <Section
                  className={`form-group ${
                    this.state.isErrPurchasingType && 'is-error'
                  }`}
                >
                  <label className="purchasing-type">Purchasing Type</label>
                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <SelectBox
                        id="active_standard_filter"
                        options={purchasingTypes}
                        placeholder="Select Purchasing Types"
                        value={this.matchValueSelected(
                          purchasingTypes,
                          formData.step2.eventInformation.purchasingType
                        )}
                        onChange={event => {
                          formData.step2.eventInformation.purchasingType =
                            event.value
                          if (this._isMounted) {
                            this.setState({
                              formData,
                            })
                          }
                        }}
                        isDisabled={!this.state.editRoleDetail ? true : false}
                      />
                    </Section>
                    <Section className="message">
                      {this.state.isErrPurchasingType && STRING.INVALID}
                    </Section>
                  </Section>
                </Section>
              </>
            ) : this.state.formData.step2.eventInformation.eventType === 2 ? (
              <>
                {/* auction type  */}
                <Section
                  className={`form-group ${
                    this.state.isErrAuctionType && 'is-error'
                  }`}
                >
                  <label className="auction-type">Auction Type</label>
                  <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper">
                      <SelectBox
                        id="active_standard_filter"
                        options={this.state.optionsAuctionType}
                        // placeholder="Select Auction Types"
                        value={this.matchValueSelected(
                          this.state.optionsAuctionType,
                          formData.step2.eventInformation.auctionType
                        )}
                        onChange={event => {
                          let isErrOpeningPrice = false
                          formData.step2.eventInformation.auctionType =
                            event.value
                          if (event.value === 2) {
                            formData.step2.eventInformation.isDisable_checkbox = true
                            formData.step2.eventInformation.is_display_dummy = false
                            formData.step2.eventInformation.is_HideLeadingBidAmount = false
                            formData.step2.eventInformation.is_HideLeadingBidTime = false
                            formData.step2.eventInformation.eventHideLeadingBidTime =
                              ''
                            formData.step2.eventInformation.eventReservePrice =
                              ''
                          } else {
                            formData.step2.eventInformation.isDisable_checkbox = false
                            isErrOpeningPrice = false
                          }
                          if (this._isMounted) {
                            this.setState({
                              formData,
                              isErrOpeningPrice,
                              isErrMaxExtensionTime: false,
                              isErrBIDMinimum: '',
                              isErrBIDDecrement: '',
                            })
                          }
                        }}
                        isDisabled={!this.state.editRoleDetail ? true : false}
                      />
                    </Section>
                    <Section className="message">
                      {this.state.isErrAuctionType && STRING.INVALID}
                    </Section>
                  </Section>
                </Section>
              </>
            ) : null}
          </Section>
        </Section>
        <Section className="form-row">
          {this.state.formData.step2.eventInformation.eventType === 1 ? (
            <>{renderToggleTypeSeal()}</>
          ) : null}
        </Section>
        {this.state.formData.step2.eventInformation.eventType === 2 && (
          <React.Fragment>
            {/* auctionTypeSealed ============================================================================== */}
            {auctionType('Sealed') && (
              <AuctionSealed
                auctionType={'Sealed'}
                formData={formData}
                isErrOpeningPrice={this.state.isErrOpeningPrice}
                isErrReservePrice={this.state.isErrReservePrice}
                editRoleDetail={this.state.editRoleDetail}
                isErrBIDDecrement={this.state.isErrBIDDecrement}
                isErrBIDMinimum={this.state.isErrBIDMinimum}
                isErrBID={this.state.isErrBID}
                isErrExtensionMinutes={this.state.isErrExtensionMinutes}
                isErrMaxExtensionTime={this.state.isErrMaxExtensionTime}
                isErrHideLeadingBidTime={this.state.isErrHideLeadingBidTime}
                isErrHideLeadingBidAmount={this.state.isErrHideLeadingBidAmount}
                isSetState={data => {
                  this.setState(data)
                  // console.log('data', data)
                }}
              />
            )}

            {/* auctionTypeEnglish ============================================================================== */}
            {auctionType('English') && (
              <AuctionEnglish
                auctionType={'English'}
                formData={formData}
                isErrOpeningPrice={this.state.isErrOpeningPrice}
                editRoleDetail={this.state.editRoleDetail}
                isErrBIDDecrement={this.state.isErrBIDDecrement}
                isErrBIDMinimum={this.state.isErrBIDMinimum}
                isErrBID={this.state.isErrBID}
                isErrExtensionMinutes={this.state.isErrExtensionMinutes}
                isErrMaxExtensionTime={this.state.isErrMaxExtensionTime}
                isSetState={data => {
                  this.setState(data)
                  // console.log('data', data)
                }}
              />
            )}
          </React.Fragment>
        )}
        {/* Internal Note and Internal Attachment */}
        <Section className="form-row">
          {/* internal note  */}
          <Section className="form-col col-6">
            <Section className="form-group">
              <label className="internal-note">
                Internal Note <br />
                {!this.state.editRoleDetail ? null : '(Optional)'}
              </label>
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <InputTextarea
                    className="input-internal-note"
                    value={formData.step2.eventInformation.internal_note}
                    onChange={e => {
                      formData.step2.eventInformation.internal_note =
                        e.target.value
                      if (this._isMounted) {
                        this.setState({
                          formData,
                        })
                      }
                    }}
                    readOnly={!this.state.editRoleDetail ? true : false}
                  />
                </Section>
                <Section className="message"></Section>
              </Section>
            </Section>
          </Section>

          {/* Internal Attachment 2 */}
          <Section className="form-col col-6">
            <Section className="form-group">
              <label className="tooltip-upload internal-attachment">
                Internal Attachment <br />
                {!this.state.editRoleDetail ? null : '(Optional)'}
                <Section className="link tooltip-attachment">
                  <Image
                    src={ICONS['icon-help.svg']}
                    alt="help"
                    tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                    useTootipFor="FileType"
                    useTootip={true}
                  />
                </Section>
              </label>
              <Section className="form-group-attached-file">
                <AttachedFile
                  id="upload-event-internal"
                  classNameInput={'form-group-attached-file-wrapper'}
                  onSelect={(file, e, cb) => {
                    console.log('file', file)
                    if (file != null) {
                      this.handlerChangeAttachFile(file, cb)
                    }
                  }}
                  isHideIput={true}
                  isDisableInput={
                    this.state.formData.step2.eventInformation.eventType == 0 ||
                    !this.state.editRoleDetail
                      ? true
                      : false
                  }
                  fileList={
                    this.state.formData.step2.eventInformation.internalFile
                  }
                  onDownload={e => {
                    this.setLoadingDownloadFile(e)
                    this.downloadInternal(e.id, e.name, this.state.activeStep)
                  }}
                  isIcon={true}
                  hasRemove={this.state.editRoleDetail}
                  onClickRemove={e => handlerClickDelete(e)}
                  loadingDownload={this.state.loadingDownloadFile}
                />
                {/* <Section className="form-group-attached-file-wrapper">
                  <InputUpload
                    id="upload"
                    isHideIput={true}
                    browseButtonText="Attach"
                    onClick={e => (e.target.value = null)}
                    onChange={this.handlerChangeAttachFile}
                    isDisable={
                      this.state.formData.step2.eventInformation.eventType ==
                        0 || !this.state.editRoleDetail
                        ? true
                        : false
                    }
                  />
                </Section> */}
                {/* {renderInternalFileStep2()} */}
              </Section>
            </Section>
          </Section>
        </Section>
      </Section>
    )
  }

  changePage = async (activePage, eventId) => {
    const { editRoleDetail } = this.state
    if (this._isMounted) {
      this.setState({ activePage: activePage })
      if (eventId && !editRoleDetail) {
        this.getProductById(eventId, activePage)
      }
    }
  }

  mapStep3 = productsList => {
    const { formData, products, UOM, editRoleDetail, offset_page } = this.state
    return productsList.map((e, i) => {
      // console.log('productsList', e)
      const mapUOM = this.matchValueSelected(UOM, e.uom_id)
      return (
        <Table.TR key={i}>
          <Table.TD className="no">
            {offset_page ? offset_page + i + 1 : i + 1}
          </Table.TD>
          <Table.TD className="item-name">
            {e.name}{' '}
            <Section className="form-group-attached-file">
              <AttachedFile
                key={i}
                id={'attached-file-item' + i}
                isUpload={false}
                isIcon={true}
                onDownload={file => {
                  // if (e) {
                  this.setLoadingDownloadFile(file)
                  this.downloadItem(file)
                  // }
                }}
                fileList={e.event_item_file || []}
                loadingDownload={this.state.loadingDownloadFile}
              />
            </Section>
          </Table.TD>

          <Table.TD className="description">{e.description}</Table.TD>

          <Table.TD className="quantity">
            {Numeral(e.req_amount).format('0,0.00')}
          </Table.TD>

          <Table.TD className="uom">{mapUOM ? mapUOM.label : null}</Table.TD>

          <Table.TD className="price">
            <Section>
              Budget Price: {Numeral(e.budget_price).format('0,0.0000')}
            </Section>
            <Section>
              Historical Price:{' '}
              {!e.historical_price || e.historical_price === 0
                ? 'N/A'
                : Numeral(e.historical_price).format('0,0.0000')}
            </Section>
            <Section>
              Market Price:{' '}
              {!e.market_price || e.market_price === 0
                ? 'N/A'
                : Numeral(e.market_price).format('0,0.0000')}
            </Section>
          </Table.TD>

          <Table.TD className="actions">
            <Section>
              <Button
                className="link"
                onClick={() => {
                  let product = JSON.parse(JSON.stringify({ ...e }))
                  if (this._isMounted) {
                    this.setState({
                      formProduct: product,
                      indexProductEdit: i,
                      isEditProduct: true,
                    })
                  }
                }}
                isDisable={!this.state.editRoleDetail ? true : false}
              >
                <Image
                  className="edit-icon"
                  src={ICONS['icon-edit.svg']}
                  alt="Edit"
                  tootipValue={`Edit`}
                  useTootipFor="Edit"
                  useTootip={true}
                />
              </Button>

              <Button
                className="link"
                onClick={() => {
                  let activePage = this.state.activePage
                  products.items.splice(i, 1)
                  if (
                    products.items &&
                    products.items.length === (this.state.activePage - 1) * 10
                  ) {
                    activePage = this.state.activePage - 1
                  }
                  if (this._isMounted) {
                    this.setState({ formData, activePage })
                  }
                }}
                isDisable={!this.state.editRoleDetail ? true : false}
              >
                <Image
                  className="delete-icon"
                  src={ICONS['icon-trash.svg']}
                  alt="Delete"
                  tootipValue={`Delete`}
                  useTootipFor="Delete"
                  useTootip={true}
                />
              </Button>
            </Section>
          </Table.TD>
        </Table.TR>
      )
    })
  }

  renderStep3TableItems = () => {
    const {
      products,
      activePage,
      limit,
      editRoleDetail,
      formData,
      total_record,
    } = this.state
    if (!!products.items && products.items.length > 0) {
      return this.mapStep3(products.items)
      // เรื่อง paginate ห้ามลบ comment
      // if (!editRoleDetail) {
      //   // ถ้า edit ไม่ได้ ใช้ paginate จาก Backend
      //   return this.mapStep3(products.items)
      // } else {
      //   // ถ้า edit ได้ ใช้ paginate จาก Forntend
      //   filterListTable3 = this.mapStep3(products.items)
      //   return pageData(filterListTable3, activePage, limit)
      // }
    }
  }

  step3Content() {
    const {
      formData,
      products,
      UOM,
      currency,
      formProduct,
      isErrProductName,
      isErrProductQty,
      isErrProductBuget,
      isErrProductUOM,
      isEditProduct,
      isErrMsgProductBuget,
      isErrMsgProductHistorical,
      isErrMsgProductMarket,
      isErrMsgProductQty,
    } = this.state
    const selectedCurency = this.matchValueSelected(
      currency,
      formData.step2.eventInformation.currency_id
    )

    // paginate
    const total_record = this.state.total_record
      ? this.state.total_record
      : products.items.length
    return (
      <Section className="form-wrapper step-2">
        <Section
          className="form-group-header"
          style={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
          <Section>
            Total {products.items ? products.items.length : total_record} items
          </Section>

          <Section>
            <Section className="form-group-control">
              <Section
                className="form-group-inner-wrapper"
                style={{ justifyContent: 'flex-end' }}
              >
                <InputUploadExcel
                  id="upload"
                  isHideIput={true}
                  browseButtonText="Upload Excel"
                  onClick={e => (e.target.value = null)}
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={async e => {
                    let files = e.target.files[0]
                    let size = 50000000
                    if (files) {
                      const isFilesType = await checkFileType(files)
                      if (isFilesType) {
                        if (files.size > size) {
                          toastFail('File size exceeded 50 Mb')
                        } else {
                          this.readUploadFile(e)
                        }
                      }
                    }
                  }}
                  isDisable={!this.state.editRoleDetail ? true : false}
                />
                <Button
                  className="theme-blue page-button download-excel-button"
                  onClick={this.onClickTemplateLink}
                  isDisable={!this.state.editRoleDetail ? true : false}
                  style={{ marginLeft: '15px' }}
                >
                  Download Excel
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        <Section className="table-wrapper">
          <Table className="sourcing-item split-row-color">
            <Table.THEAD>
              <Table.TR>
                <Table.TH className="no">NO.</Table.TH>

                <Table.TH className="item-name">ITEM NAME</Table.TH>

                <Table.TH className="description">DESCRIPTION</Table.TH>

                <Table.TH className="quantity">QTY</Table.TH>

                <Table.TH className="uom">UOM</Table.TH>

                <Table.TH className="price">
                  {`UNIT PRICE: ${
                    selectedCurency ? selectedCurency.label : 'THB'
                  }`}
                </Table.TH>

                <Table.TH className="actions">ACTIONS</Table.TH>
              </Table.TR>
            </Table.THEAD>

            <Table.TBODY>{this.renderStep3TableItems()}</Table.TBODY>

            <Table.TBODY>
              <Table.TR className="sourcing-item-add">
                <Table.TD className="no">&nbsp;</Table.TD>

                <Table.TD className="item-name">
                  <Section
                    className={`form-group ${isErrProductName && 'is-error'}`}
                  >
                    <Section className="form-group-control">
                      <Section
                        className="form-group-inner-wrapper"
                        onBlur={() => {
                          formProduct.name = formProduct.name.trimEnd()
                          if (this._isMounted) {
                            this.setState({
                              formData,
                            })
                          }
                        }}
                      >
                        <Input
                          placeholder="Item Name"
                          type="text"
                          value={formProduct.name}
                          onChange={event => {
                            formProduct.name = event.target.value.trimStart()
                            if (this._isMounted) {
                              this.setState({
                                formProduct,
                                isErrProductName: false,
                              })
                            }
                          }}
                          readOnly={!this.state.editRoleDetail ? true : false}
                        />
                      </Section>
                      <Section className="message">
                        {isErrProductName && STRING.INVALID}
                      </Section>
                    </Section>
                  </Section>
                  {/* <Section className="form-group-control">
                    <Section className="form-group-inner-wrapper tooltip-upload">
                      <InputUpload
                        id="upload-file-step3"
                        isHideIput={true}
                        browseButtonText="Attach"
                        onClick={e => (e.target.value = null)}
                        onChange={async e => {
                          let files = e.target.files[0]
                          let size = 50000000
                          if (files) {
                            const isFilesType = await checkFileType(files)
                            if (isFilesType) {
                              if (files.size > size) {
                                toastFail('File size exceeded 50 Mb')
                              } else {
                                this.uploadItemFile(e)
                              }
                            }
                          }
                        }}
                        isDisable={!this.state.editRoleDetail ? true : false}
                      />
                      <Image
                        src={ICONS['icon-help.svg']}
                        alt="help"
                        tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                        useTootipFor="FileType"
                        useTootip={true}
                        style={{
                          position: 'relative',
                          top: '-8px',
                        }}
                      />
                    </Section>
                  </Section> */}
                  {/* <Section className="form-group-attached-file">
                    {formProduct.event_item_file &&
                      formProduct.event_item_file.map((e, i) => {
                        return (
                          <>
                            <AttachedFile
                              key={i}
                              id={'attached-file-' + e.id}
                              isIcon={true}
                              onClick={() => {
                                this.setLoadingDownloadFile(e)
                                this.downloadItem(e)
                              }}
                              fileName={e.name}
                              hasRemove={this.state.editRoleDetail}
                              onClickRemove={() => {
                                formProduct.event_item_file.splice(i, 1),
                                  this.forceUpdate()
                              }}
                              isUpload={false}
                            />
                            {this.renderDownloadFile(e)}
                          </>
                        )
                      })}
                  </Section> */}
                  <AttachedFile
                    id="upload-file-step3"
                    classNameInput={'form-group-inner-wrapper tooltip-upload'}
                    isHideIput={true}
                    browseButtonText="Attach"
                    isDisableInput={!this.state.editRoleDetail ? true : false}
                    onSelect={(file, e, cb) => {
                      // console.log('file', file)
                      if (file != null) {
                        // this.handlerChangeAttachFile(file, cb)
                        this.uploadItemFile(file)
                        cb()
                      }
                    }}
                    isHelp={true}
                    isIcon={true}
                    hasRemove={this.state.editRoleDetail}
                    fileList={
                      formProduct.event_item_file
                        ? formProduct.event_item_file
                        : []
                    }
                    onDownload={file => {
                      this.setLoadingDownloadFile(file)
                      this.downloadItem(file)
                    }}
                    onClickRemove={e => {
                      if (e.id) {
                        e.is_deleted = true
                        this.setState({
                          formProduct,
                        })
                      }
                    }}
                    loadingDownload={this.state.loadingDownloadFile}
                  />
                </Table.TD>
                <Table.TD className="description">
                  <Section
                    className={`form-group ${
                      this.state.isErrProductDescription && 'is-error'
                    }`}
                  >
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <InputTextarea
                          placeholder="Description (Optional)"
                          value={formProduct.description}
                          onChange={event => {
                            formProduct.description = event.target.value
                            if (this._isMounted) {
                              this.setState({
                                formProduct,
                                isErrProductDescription: false,
                              })
                            }
                          }}
                          readOnly={!this.state.editRoleDetail ? true : false}
                        />
                      </Section>
                      <Section className="message">
                        {this.state.isErrProductDescription && STRING.INVALID}
                      </Section>
                    </Section>
                  </Section>
                </Table.TD>
                <Table.TD className="quantity">
                  <Section
                    className={`form-group ${isErrProductQty && 'is-error'}`}
                  >
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <NumberFormat
                          placeholder="Qty"
                          maxLength={13}
                          value={formProduct.req_amount}
                          allowNegative={false}
                          isAllowed={values => {
                            const { value, floatValue } = values
                            if (
                              typeof floatValue === 'undefined' ||
                              typeof value === 'undefined'
                            ) {
                              return true
                            }
                            if (value.charAt(0) === '0') {
                              if (value.charAt(1) && value.charAt(1) != '.') {
                                return false
                              }
                            }
                            return true
                          }}
                          customInput={Input}
                          decimalScale={2}
                          onChange={e => {
                            if (!e.target.value) {
                              formProduct.req_amount = null
                            } else {
                              formProduct.req_amount = parseFloat(
                                Numeral(e.target.value).format('0.00')
                              )
                            }
                            if (this._isMounted) {
                              this.setState({
                                formProduct,
                                isErrProductQty: false,
                              })
                            }
                          }}
                          thousandSeparator={true}
                          readOnly={!this.state.editRoleDetail ? true : false}
                        />
                      </Section>
                      {/* <Section className="message">
                        {isErrProductQty && STRING.INVALID}
                      </Section> */}

                      {isErrProductQty ? (
                        <Section className="message">
                          {isErrProductQty && isErrMsgProductQty
                            ? isErrMsgProductQty
                            : isErrProductQty && !isErrMsgProductQty
                            ? STRING.INVALID
                            : ''}
                        </Section>
                      ) : null}
                    </Section>
                  </Section>
                </Table.TD>

                <Table.TD className="uom">
                  <Section
                    className={`form-group ${isErrProductUOM && 'is-error'}`}
                  >
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <SelectBox
                          id="uom_id"
                          options={UOM}
                          placeholder="Select"
                          menuPortalTarget={document.body}
                          value={
                            formProduct.uom_id !== null
                              ? this.matchValueSelected(UOM, formProduct.uom_id)
                              : null
                          }
                          onChange={event => {
                            formProduct.uom_id = event.value
                            if (this._isMounted) {
                              this.setState({
                                formProduct,
                                isErrProductUOM: false,
                              })
                            }
                          }}
                          isDisabled={!this.state.editRoleDetail ? true : false}
                        />
                      </Section>
                      <Section className="message">
                        {isErrProductUOM && STRING.INVALID}
                      </Section>
                    </Section>
                  </Section>
                </Table.TD>

                <Table.TD className="price">
                  <Section
                    className={`form-group ${isErrProductBuget && 'is-error'}`}
                  >
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <NumberFormat
                          id="budget_price"
                          allowNegative={false}
                          isAllowed={values => {
                            const { value, floatValue } = values
                            if (
                              typeof floatValue === 'undefined' ||
                              typeof value === 'undefined'
                            ) {
                              return true
                            }
                            if (value.charAt(0) === '0') {
                              if (value.charAt(1) && value.charAt(1) != '.') {
                                return false
                              }
                            }
                            return true
                          }}
                          maxLength={18}
                          placeholder="Budget Price"
                          value={formProduct.budget_price}
                          customInput={Input}
                          decimalScale={4}
                          onChange={e => {
                            if (!e.target.value) {
                              formProduct.budget_price = null
                            } else {
                              formProduct.budget_price = parseFloat(
                                Numeral(e.target.value).format('0.0000')
                              )
                            }
                            if (this._isMounted) {
                              this.setState({
                                formProduct,
                                isErrProductBuget: false,
                              })
                            }
                          }}
                          thousandSeparator={true}
                          readOnly={!this.state.editRoleDetail ? true : false}
                        />
                      </Section>
                      {isErrProductBuget ? (
                        <Section className="message">
                          {isErrProductBuget && isErrMsgProductBuget
                            ? isErrMsgProductBuget
                            : isErrProductBuget && !isErrMsgProductBuget
                            ? STRING.INVALID
                            : ''}
                        </Section>
                      ) : null}
                    </Section>
                  </Section>

                  <Section
                    className={`form-group ${
                      isErrMsgProductHistorical && 'is-error'
                    }`}
                  >
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <NumberFormat
                          id="historical_price"
                          allowNegative={false}
                          isAllowed={values => {
                            const { value, floatValue } = values
                            if (
                              typeof floatValue === 'undefined' ||
                              typeof value === 'undefined'
                            ) {
                              return true
                            }
                            if (value.charAt(0) === '0') {
                              if (value.charAt(1) && value.charAt(1) != '.') {
                                return false
                              }
                            }
                            return true
                          }}
                          placeholder="Historical Price (Optional)"
                          maxLength={18}
                          value={formProduct.historical_price}
                          customInput={Input}
                          decimalScale={4}
                          onChange={e => {
                            if (!e.target.value) {
                              formProduct.historical_price = null
                            } else {
                              formProduct.historical_price = parseFloat(
                                Numeral(e.target.value).format('0.0000')
                              )
                            }
                            if (this._isMounted) {
                              this.setState({
                                formProduct,
                                isErrMsgProductHistorical: false,
                              })
                            }
                          }}
                          thousandSeparator={true}
                          readOnly={!this.state.editRoleDetail ? true : false}
                        />
                      </Section>
                      {isErrMsgProductHistorical ? (
                        <Section className="message">
                          {isErrMsgProductHistorical &&
                            isErrMsgProductHistorical}
                        </Section>
                      ) : null}
                    </Section>
                  </Section>

                  <Section
                    className={`form-group ${
                      isErrMsgProductMarket && 'is-error'
                    }`}
                  >
                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <NumberFormat
                          id="market_price"
                          placeholder="Market Price (Optional)"
                          maxLength={18}
                          allowNegative={false}
                          isAllowed={values => {
                            const { value, floatValue } = values
                            if (
                              typeof floatValue === 'undefined' ||
                              typeof value === 'undefined'
                            ) {
                              return true
                            }
                            if (value.charAt(0) === '0') {
                              if (value.charAt(1) && value.charAt(1) != '.') {
                                return false
                              }
                            }
                            return true
                          }}
                          value={formProduct.market_price}
                          customInput={Input}
                          decimalScale={4}
                          onChange={e => {
                            if (!e.target.value) {
                              formProduct.market_price = null
                            } else {
                              formProduct.market_price = parseFloat(
                                Numeral(e.target.value).format('0.0000')
                              )
                            }
                            if (this._isMounted) {
                              this.setState({
                                formProduct,
                                isErrMsgProductMarket: false,
                              })
                            }
                          }}
                          thousandSeparator={true}
                          readOnly={!this.state.editRoleDetail ? true : false}
                        />
                      </Section>
                      {isErrMsgProductMarket ? (
                        <Section className="message">
                          {isErrMsgProductMarket && isErrMsgProductMarket}
                        </Section>
                      ) : null}
                    </Section>
                  </Section>
                </Table.TD>

                <Table.TD className="actionEdit" id="actions">
                  <Section className="add-new">
                    <Button
                      // className="add-new"
                      className={isEditProduct ? 'theme-green' : 'theme-blue'}
                      onClick={() => {
                        isEditProduct ? this.editProduct() : this.addProduct()
                      }}
                      isDisable={
                        this.state.isUpload
                          ? true
                          : !this.state.editRoleDetail
                          ? true
                          : false
                      }
                    >
                      {/* <Image
                        src={ICONS['icon-add-circular.svg']}
                        alt="add icon"
                      /> */}
                      {isEditProduct ? 'Update' : 'Add'}
                    </Button>
                  </Section>
                  {isEditProduct ? (
                    <Section className="add-new">
                      <Button
                        className="theme-border-gray"
                        onClick={() => {
                          if (this._isMounted) {
                            return this.setState({
                              isEditProduct: false,
                              indexProductEdit: null,
                              formProduct: {
                                budget_price: null,
                                description: '',
                                historical_price: null,
                                market_price: null,
                                name: '',
                                req_amount: '',
                                uom_id: '',
                                rfq_buyer_item_file: [],
                              },
                            })
                          }
                        }}
                      >
                        {/* <Image
                        src={ICONS['icon-add-circular.svg']}
                        alt="add icon"
                      /> */}
                        Cancel
                      </Button>
                    </Section>
                  ) : null}
                </Table.TD>
              </Table.TR>
            </Table.TBODY>
          </Table>

          {/* pagination items ห้ามลบ comment */}
          {/* {total_record > 10 && (
            <Section className="content-footer">
              <Section className="showing-item">
                Showing {(this.state.activePage - 1) * 10 + 1} to{' '}
                {this.state.activePage > Math.floor(total_record / 10)
                  ? (this.state.activePage - 1) * 10 + (total_record % 10)
                  : this.state.activePage * 10}{' '}
                of {total_record} items
              </Section>
              <Section className="paginate-wrapper">
                <Paginate
                  activePage={this.state.activePage}
                  itemsCountPerPage={this.state.limit}
                  totalItemsCount={total_record}
                  onChange={e => {
                    return this.changePage(
                      e,
                      formData.step2.eventInformation.eventId
                    )
                  }}
                />
                <Section className="moveto-wrapper">
                  <NumberFormat
                    value={this.state.searchPage}
                    label="Page"
                    isHorizontal
                    className="paginate-moveto"
                    defaultValue="1"
                    maxLength="4"
                    customInput={Input}
                    decimalSeparator={false}
                    allowNegative={false}
                    allowLeadingZeros={false}
                    onChange={e => {
                      if (this._isMounted) {
                        return this.setState({
                          searchPage:
                            parseInt(e.target.value) >
                            Math.floor(total_record / 10) + 1
                              ? Math.floor(total_record / 10) + 1
                              : parseInt(e.target.value),
                        })
                      }
                    }}
                    isAllowed={values => {
                      return isAllowedChangePage(values, this.props.maximum)
                    }}
                  />
                  <Button
                    onClick={() => {
                      if (this.state.searchPage) {
                        return this.changePage(
                          this.state.searchPage,
                          formData.step2.eventInformation.eventId
                        )
                      }
                    }}
                  >
                    go
                  </Button>
                </Section>
              </Section>
            </Section>
          )} */}
        </Section>
      </Section>
    )
  }

  onSelectSupplierRqf = (supplier, index, e) => {
    let { stackSelectSuppliersRfq, suppliersRfq } = this.state
    if (supplier && !isNaN(index)) {
      const suppliersRfqDisabled = suppliersRfq.map(supRfq => {
        if (
          supplier.TaxID === supRfq.TaxID &&
          supplier.SupplierID === supRfq.SupplierID
        ) {
          const indexStackSelectSuppliersRfq = stackSelectSuppliersRfq.findIndex(
            sup => supRfq.SupplierID === sup.SupplierID
          )
          if (!supRfq.checked) {
            stackSelectSuppliersRfq.push(supRfq)
          } else {
            stackSelectSuppliersRfq.splice(indexStackSelectSuppliersRfq, 1)
          }
          return { ...supRfq, checked: !supRfq.checked, disabled: false }
        } else if (
          supplier.TaxID === supRfq.TaxID &&
          supplier.Branch !== supRfq.Branch
        ) {
          return { ...supRfq }
        } else if (
          supplier.TaxID === supRfq.TaxID &&
          supplier.SupplierID !== supRfq.SupplierID
        ) {
          // const indexStackSelectSuppliersRfq = stackSelectSuppliersRfq.findIndex(
          //   sup => supRfq.SupplierID === sup.SupplierID
          // )
          // if (indexStackSelectSuppliersRfq > 0) {
          //   stackSelectSuppliersRfq.splice(indexStackSelectSuppliersRfq, 1)
          // }
          let isDisable = false
          if (e.target.checked) {
            if (supplier.Branch === supRfq.Branch) {
              isDisable = true
            } else {
              isDisable = false
            }
          } else {
            if (supplier.Branch === supRfq.Branch) {
              isDisable = false
            } else {
              isDisable = true
            }
          }
          // let isDisable = false
          // if (supplier.Branch === supRfq.Branch) {
          //   isDisable = true
          // } else {
          //   isDisable = false
          // }
          return { ...supRfq, disabled: isDisable }
        } else {
          return { ...supRfq }
        }
      })
      if (this._isMounted) {
        this.setState({
          stackSelectSuppliersRfq,
          suppliersRfq: suppliersRfqDisabled,
        })
      }
    }
  }

  onClickOKSupplierRfq = () => {
    if (this._isMounted) {
      this.setState({
        searchKeywords: '',
      })
    }
    this.setSelectSupplierRfq()
    this.getMaster.getSupplierRqf('', 1, true)
    this.toggleModal()
  }

  setSelectSupplierRfq = () => {
    let { selectSuppliersRfq, stackSelectSuppliersRfq } = this.state
    selectSuppliersRfq = [...stackSelectSuppliersRfq]
    if (this._isMounted) {
      this.setState({ selectSuppliersRfq })
    }
  }

  onClickCancelSelectSupplierRfq = () => {
    const { suppliersRfq } = this.state
    const suppliersRfqDefault = suppliersRfq.map(sup => {
      return { ...sup, checked: false, disabled: false }
    })
    if (this._isMounted) {
      this.setState({
        suppliersRfq: suppliersRfqDefault,
        searchKeywords: '',
      })
    }
    this.getMaster.getSupplierRqf('', 1, true)
    this.toggleModal()
  }

  onClickDeleateSupplierRfqSelect = (supplier, index) => {
    let {
      selectSuppliersRfq,
      suppliersRfq,
      stackSelectSuppliersRfq,
    } = this.state

    const suppliersRfqDisabled = suppliersRfq.map(supRfq => {
      if (
        supplier.TaxID === supRfq.TaxID &&
        supplier.SupplierID === supRfq.SupplierID
      ) {
        return { ...supRfq, checked: false, disabled: false }
      } else if (
        supplier.TaxID === supRfq.TaxID &&
        supplier.SupplierID !== supRfq.SupplierID
      ) {
        return { ...supRfq, disabled: false }
      } else {
        return { ...supRfq }
      }
    })

    selectSuppliersRfq.splice(index, 1)
    stackSelectSuppliersRfq = [...selectSuppliersRfq]
    if (this._isMounted) {
      this.setState(
        {
          selectSuppliersRfq,
          stackSelectSuppliersRfq,
          suppliersRfq: suppliersRfqDisabled,
        },
        this.forceUpdate()
      )
    }
  }

  onClickOpenSupplierRfq = () => {
    let {
      suppliersRfq,
      selectSuppliersRfq,
      stackSelectSuppliersRfq,
    } = this.state

    selectSuppliersRfq.map(e => {
      const index = suppliersRfq.findIndex(
        sup => sup.SupplierID === e.SupplierID
      )

      const suppliersRfqDisabled = suppliersRfq.map(supRfq => {
        const selectSupplierRfqMatching =
          e.TaxID === supRfq.TaxID && e.SupplierID === supRfq.SupplierID
        const selectSupplierRfqDupplicate =
          e.TaxID === supRfq.TaxID && e.SupplierID !== supRfq.SupplierID

        if (selectSupplierRfqMatching) {
          return { ...supRfq, checked: true, disabled: false }
        } else if (selectSupplierRfqDupplicate) {
          if (e.Branch === supRfq.Branch) {
            return { ...supRfq, disabled: true }
          } else {
            return { ...supRfq, disabled: false }
          }
        } else {
          return { ...supRfq }
        }
      })
      suppliersRfq = suppliersRfqDisabled
      if (suppliersRfq[index]) {
        suppliersRfq[index].checked = true
      }
    })
    stackSelectSuppliersRfq = [...selectSuppliersRfq]
    if (this._isMounted) {
      this.setState(
        { suppliersRfq, stackSelectSuppliersRfq },
        this.toggleModal('add-supplier')
      )
    }
  }

  onSearchSupplierRfqChange = e => {
    if (e && e.target) {
      if (this._isMounted) {
        return this.setState({ searchKeywords: e.target.value })
      }
    }
  }

  onClickSearchSupplierRfq = () => {
    this.getMaster.getSupplierRqf(this.state.searchKeywords, 1, true)
  }

  renderSuppliersRqf = (suppliersRfq = []) => {
    if (suppliersRfq.length > 0) {
      return suppliersRfq.map((sup, index) => {
        const waitActive = sup.StatusActive === 2
        if (waitActive) {
          return (
            <Table.TR key={index}>
              <Table.TD className="tax-id">
                <Text>
                  <div className="wrong-status">{sup.TaxID}</div>
                </Text>
              </Table.TD>

              <Table.TD
                className="company-name"
                style={{ textOverflow: 'ellipsis' }}
              >
                <div className="wrong-status">
                  <label>
                    <Text
                      tootipValue={sup.CompanyName}
                      useTootipFor="company-name"
                      useTootip={true}
                    >
                      {sup.CompanyName}
                    </Text>
                  </label>
                  <Image
                    src={ICONS['icon-wrong.svg']}
                    alt="help"
                    className="wrong-icon"
                    tootipValue={sup.Warning}
                    // tootipHtmlValue={[
                    //   'Invited: ',
                    //   <br key={'key'} />,
                    //   dateMonDayYearTime(supplierData.register_date),
                    // ]}
                    useTootipFor="iiiujyh"
                    useTootip={true}
                  />
                </div>
              </Table.TD>

              <Table.TD className="branch-number">
                <div className="wrong-status">
                  {<Text>{sup.Branch}</Text> ? (
                    <Text>{sup.Branch}</Text>
                  ) : (
                    'Not Specify'
                  )}
                </div>
              </Table.TD>
              <Table.TD className="vendor-code">
                <Text>
                  <div className="wrong-status">{sup.VendorCode}</div>
                </Text>
              </Table.TD>

              <Table.TD className="contact-name">
                <Text>
                  <div className="wrong-status">{sup.ContactName}</div>
                </Text>
              </Table.TD>
              <Table.TD className="email">
                <Text>
                  <div
                    style={{ textTransform: 'unset' }}
                    className="wrong-status"
                  >
                    {sup.ContactEmail}
                  </div>
                </Text>
              </Table.TD>
            </Table.TR>
          )
        } else {
          return (
            <Table.TR key={index}>
              <Table.TD className="tax-id">
                <Checkbox
                  id={index}
                  value={sup.TaxID}
                  checked={sup.checked}
                  onChange={e => {
                    this.onSelectSupplierRqf(sup, index, e)
                  }}
                  disabled={sup.disabled}
                >
                  <Text>{sup.TaxID}</Text>
                </Checkbox>
              </Table.TD>
              <Table.TD
                className="company-name"
                style={{ textOverflow: 'ellipsis' }}
              >
                <Text
                  tootipValue={sup.CompanyName}
                  useTootipFor="company-name"
                  useTootip={true}
                >
                  {sup.CompanyName}
                </Text>
              </Table.TD>
              <Table.TD className="branch-number">
                {<Text>{sup.Branch}</Text> ? (
                  <Text>{sup.Branch}</Text>
                ) : (
                  'Not Specify'
                )}
              </Table.TD>
              <Table.TD className="vendor-code">
                <Text>{sup.VendorCode}</Text>
              </Table.TD>
              <Table.TD className="contact-name">
                <Text>{sup.ContactName}</Text>
              </Table.TD>
              <Table.TD className="email">
                <Text>{sup.ContactEmail}</Text>
              </Table.TD>
            </Table.TR>
          )
        }
      })
    } else {
      return (
        <Table.TR>
          <Table.TD>
            <Section className="no-result-found">
              <Image src={ICONS['icon-ssr.png']} className="no-result" />
              <p>No result found</p>
            </Section>
          </Table.TD>
        </Table.TR>
      )
    }
  }

  renderSuppliersRfqSelect = () => {
    const { selectSuppliersRfq } = this.state
    const filterSup = filter(selectSuppliersRfq, value => value !== undefined)
    return map(filterSup, (sup, index) => {
      return (
        <Table.TR key={index + sup.TaxID}>
          <Table.TD className="no">{index + 1}</Table.TD>
          <Table.TD className="tax-id">
            <Text
              tootipValue={sup.TaxID}
              useTootipFor="tax-id"
              useTootip={true}
            >
              {sup.TaxID}
            </Text>
          </Table.TD>

          <Table.TD className="company-name">
            <Text
              tootipValue={sup.CompanyName}
              useTootipFor="company-name"
              useTootip={true}
            >
              {sup.CompanyName}
            </Text>
          </Table.TD>

          <Table.TD className="branch-number">
            {<Text
              tootipValue={sup.Branch}
              useTootipFor="company-name"
              useTootip={true}
            >
              {sup.Branch}
            </Text> ? (
              <Text
                tootipValue={sup.Branch}
                useTootipFor="company-name"
                useTootip={true}
              >
                {sup.Branch}
              </Text>
            ) : (
              'Not Specify'
            )}
          </Table.TD>

          <Table.TD className="vendor-code">
            <Text
              tootipValue={sup.VendorCode}
              useTootipFor="vendor-code"
              useTootip={true}
            >
              {sup.VendorCode}
            </Text>
          </Table.TD>

          <Table.TD className="contact-name">
            <Text
              tootipValue={sup.ContactName}
              useTootipFor="contact-name"
              useTootip={true}
            >
              {sup.ContactName}
            </Text>
          </Table.TD>

          <Table.TD className="email">
            <Text
              tootipValue={sup.ContactEmail}
              useTootipFor="email"
              useTootip={true}
            >
              {sup.ContactEmail}
            </Text>
          </Table.TD>

          <Table.TD className="phone">
            <Text
              tootipValue={sup.ContactPhone}
              useTootipFor="phone"
              useTootip={true}
            >
              {sup.ContactPhone}
            </Text>
          </Table.TD>

          <Table.TD className="actions">
            <Section>
              <Button
                className="link"
                onClick={() => this.onClickDeleateSupplierRfqSelect(sup, index)}
                isDisable={!this.state.editRoleDetail ? true : false}
              >
                <Image
                  className="delete-icon"
                  src={ICONS['icon-trash.svg']}
                  alt="Delete"
                  tootipValue={`Delete`}
                  useTootipFor="Delete"
                  useTootip={true}
                />
              </Button>
            </Section>
          </Table.TD>
        </Table.TR>
      )
    })
  }

  step4Content() {
    const {
      formData,
      isErrStartDate,
      isErrEndDate,
      externalFile,
      isErrMsgEndDate,
      isErrMsgStartDate,
    } = this.state
    return (
      <Section className="form-wrapper add-supplier">
        <Section className="page-button">
          <Button
            className="page-button"
            onClick={() => this.onClickOpenSupplierRfq()}
            isDisable={!this.state.editRoleDetail ? true : false}
          >
            {/* <Image src={ICONS['icon-add-circular.svg']} alt="add icon" /> */}
            Add Supplier
          </Button>
        </Section>

        <Section className="table-wrapper">
          <Table className="buyer split-row-color">
            {/* Header Row */}
            <Table.THEAD>
              <Table.TR className="header">
                <Table.TH className="no" id="no_header">
                  NO.
                </Table.TH>
                <Table.TH className="tax-id" id="tax_id_header">
                  TAX ID
                </Table.TH>

                <Table.TH className="company-name" id="company_name_header">
                  SUPPLIER NAME
                </Table.TH>

                <Table.TH className="branch-number" id="main_directory_header">
                  BRANCH
                </Table.TH>

                <Table.TH className="vendor-code" id="vendor_code">
                  SUPPLIER NO.
                </Table.TH>

                <Table.TH className="contact-name" id="contact_name">
                  CONTACT NAME
                </Table.TH>

                <Table.TH className="email" id="email_header">
                  CONTACT EMAIL
                </Table.TH>

                <Table.TH className="phone" id="phone_header">
                  PHONE
                </Table.TH>

                <Table.TH className="actions" id="actions_header">
                  ACTIONS
                </Table.TH>
              </Table.TR>
            </Table.THEAD>

            <Table.TBODY>{this.renderSuppliersRfqSelect()}</Table.TBODY>
          </Table>
        </Section>

        <Section className="form-row form-row-title form-group-header">
          <label>Sourcing Period</label>
        </Section>

        <Section className="form-row">
          <Section className="form-col col-6">
            <Section
              className={`form-group date-period ${
                isErrStartDate && 'is-error'
              }`}
            >
              <label>Start Date</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <DatePickerInput
                    selected={formData.start_date ? formData.start_date : null}
                    onChange={date => {
                      formData.start_date = date
                      if (this._isMounted) {
                        return this.setState({
                          formData,
                          isErrStartDate: false,
                        })
                      }
                    }}
                    openToDate={new Date()}
                    // selectsStart
                    minDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    showTimeSelect
                    dateFormat="MMM d, yyyy hh:mm aa"
                    timeIntervals={1}
                    dropdownMode="select"
                    disabled={!this.state.editRoleDetail ? true : false}
                  />
                </Section>

                <Section className="message">
                  {isErrStartDate && isErrMsgStartDate
                    ? isErrMsgStartDate
                    : isErrStartDate && !isErrMsgStartDate
                    ? STRING.INVALID
                    : ''}
                </Section>
              </Section>
            </Section>
          </Section>

          <Section className="form-col col-6">
            <Section
              className={`form-group date-period ${isErrEndDate && 'is-error'}`}
            >
              <label>End Date</label>

              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <DatePickerInput
                    selected={formData.end_date ? formData.end_date : null}
                    onChange={date => {
                      formData.end_date = date
                      if (this._isMounted) {
                        return this.setState({
                          formData,
                          isErrEndDate: false,
                        })
                      }
                    }}
                    // selectsStart
                    minDate={formData.start_date}
                    showMonthDropdown
                    showYearDropdown
                    showTimeSelect
                    dateFormat="MMM d, yyyy hh:mm aa"
                    timeIntervals={1}
                    dropdownMode="select"
                    disabled={!this.state.editRoleDetail ? true : false}
                  />
                </Section>
                <Section className="message">
                  {isErrEndDate && isErrMsgEndDate
                    ? isErrMsgEndDate
                    : isErrEndDate && !isErrMsgEndDate
                    ? STRING.INVALID
                    : ''}
                </Section>
              </Section>
            </Section>
          </Section>
        </Section>

        <Section className="form-row form-row-title form-group-header">
          <label>Note To Supplier</label>
        </Section>
        <Section className="form-group">
          <label>
            Note <br />
            {!this.state.editRoleDetail ? null : '(Optional)'}
          </label>
          <Section className="form-group-control">
            <Section className="form-group-inner-wrapper">
              <InputTextarea
                value={formData.note_to_supplier}
                onChange={e => {
                  formData.note_to_supplier = e.target.value
                  if (this._isMounted) {
                    this.setState({
                      formData,
                    })
                  }
                }}
                isDisable={!this.state.editRoleDetail ? true : false}
              />
            </Section>
            <Section className="message"></Section>
          </Section>
        </Section>

        <Section className="form-group">
          <label className="tooltip-upload">
            Attachment <br />
            {!this.state.editRoleDetail ? null : '(Optional)'}
            <Section className="link tooltip-attachment">
              <Image
                src={ICONS['icon-help.svg']}
                alt="help"
                tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                useTootipFor="FileType"
                useTootip={true}
              />
            </Section>
          </label>
          <Section className="form-group-attached-file">
            <AttachedFile
              id="upload-attachment-external"
              isHideIput={true}
              browseButtonText="Attach"
              onSelect={(file, e, cb) => {
                console.log('file', file)
                if (file != null) {
                  this.onChangeFileExternal(file, cb)
                }
              }}
              hasRemove={true}
              isDisableInput={!this.state.editRoleDetail ? true : false}
              fileList={externalFile}
              onDownload={e => {
                this.setLoadingDownloadFile(e)
                this.downloadExternal(e)
              }}
              onClickRemove={e => {
                if (e.id) {
                  e.is_deleted = true
                  this.setState({ externalFile })
                }
              }}
              loadingDownload={this.state.loadingDownloadFile}
            />
            {/* <Section className="form-group-attached-file-wrapper">
              <InputUpload
                id="upload"
                isHideIput={true}
                browseButtonText="Attach"
                onClick={e => (e.target.value = null)}
                onChange={e => {
                  this.onChangeFileExternal(e)
                }}
                isDisable={!this.state.editRoleDetail ? true : false}
              />
            </Section>
            <Section className="form-group-attached-file">
              {externalFile &&
                externalFile.map((e, i) => {
                  return (
                    !e.is_deleted && (
                      <Section className="form-group-attached-file-wrapper">
                        <AttachedFile
                          key={i}
                          id={'attached-file-' + e.id}
                          isIcon={true}
                          onClick={() => {
                            if (e.id) {
                              this.setLoadingDownloadFile(e)
                              this.downloadExternal(e)
                            }
                            // e.id ? this.downloadExternal(e) : null
                          }}
                          fileName={e.name}
                          hasRemove={this.state.editRoleDetail}
                          onClickRemove={() => {
                            externalFile[i].is_deleted = true
                            if (this._isMounted) {
                              return this.setState({ externalFile })
                            }
                          }}
                        />
                        {this.renderDownloadFile(e)}
                      </Section>
                    )
                  )
                })}
            </Section> */}
          </Section>
        </Section>
      </Section>
    )
  }
  confirmOnClickModal = () => {
    this.toggleModal('confirm-submit')
    document.body.classList.remove('modal-open')
    if (this.validateSubmit()) {
      // this.toggleModal('confirm-submit')
      // document.body.classList.remove('modal-open')
      if (this._isMounted && !this.state.isLoading) {
        this.setState(function (previousState, currentProps) {
          return {
            clicks: previousState.clicks + 1,
          }
        })
        return this.setState({ isLoading: true }, this.onSubmit)
      }
    }
  }

  switchEventClearData = () => {
    this.setState({
      formData: {
        id: this.state.formData.id,
        rfq_status_id: this.state.formData.rfq_status_id,
        sourcing_project_attachment_files_request: this.state.formData
          .sourcing_project_attachment_files_request,
        step1: this.state.formData.step1,
        step2: {
          eventInformation: {
            idRfq: this.state.formData.step2.eventInformation.idRfq,
            idAuction: this.state.formData.step2.eventInformation.idAuction,
            // eventType: this.state.formData.step2.eventInformation.eventType,
            eventType: this.state.selectedEventType,
            eventName: this.state.formData.step2.eventInformation.eventName,
            is_BidType: 1,
            is_vat: false,
            currency_id: currencyIdFunc(),
            purchasingType: 1,
            seal_type: false,
            auction_award_status_id: 1,
            auction_status_id: 1,
            auctionType: 1,
            eventOpeningPrice: '',
            eventReservePrice: '',
            is_ExtensionTime: false,
            eventExtensionMinutes: '',
            bidSubmission: 1,
            is_MaxExtension: true,
            eventExtensionTime: '',
            is_display_dummy: false,
            eventHideLeadingBidTime: '',
            isDisable_checkbox: false,
            description: '',
            is_HideLeadingBidAmount: false,
            is_HideLeadingBidTime: false,
            internal_note: '',
            internalFile: this.state.formData.step2.eventInformation
              .internalFile,
            seal_status: 0,
            is_bid: false,
            bid_decrement: '',
            bid_minimum: '',
          },
        },
        note_to_supplier: '',
      },
      products: {
        items: [],
      },
      formProduct: {
        budget_price: null,
        description: '',
        historical_price: null,
        market_price: null,
        name: '',
        req_amount: null,
        uom_id: null,
        rfq_buyer_item_file: [],
        auction_buyer_item_file: [],
      },
      externalFile: [],
      startDate: undefined,
      endDate: undefined,
      // suppliersRfq: [], // supplier in modal Add Supplier // อันนี้เม้นอยู่แล้ว
      selectSuppliersRfq: [],
      stackSelectSuppliersRfq: [],
    })
    this.toggleModal('confirm-switch-event')
    document.body.classList.remove('modal-open')
  }

  isFileLoading() {
    const {
      loadingFileInternal,
      loadingFileStep2,
      loadingFileStep3,
    } = this.state

    const isLoading =
      loadingFileInternal || loadingFileStep2 || loadingFileStep3
    // console.log(
    //   'isLoading',
    //   loadingFileInternal,
    //   loadingFileStep2,
    //   loadingFileStep3
    // )
    return isLoading
  }

  renderCreateEventModal = (activeStep, steps) => {
    const funcRenderStep = () => {
      const text = {
        textSourcing: 'Sourcing Project',
        textEvent: 'Event Information',
        textEventItems: 'Event Items',
        textEventSummary: 'Event Summary',
      }
      switch (activeStep) {
        case 1: {
          return `Step ${activeStep + 1} : ${text.textEvent}`
        }
        case 2: {
          return `Step ${activeStep + 1} : ${text.textEventItems}`
        }
        case 3: {
          return `Step ${activeStep + 1} : ${text.textEventSummary}`
        }
        default: {
          return `Step ${activeStep + 1} : ${text.textSourcing}`
        }
      }
    }
    const funcRenderStepper = () => {
      const render = (v, k) => {
        const handlerClickStepper = e => {
          if (activeStep < k) {
            const isPassValidate = this.validateActiveStep()
            if (isPassValidate) {
              return this.handleStepChange(k)
            } else {
              return null
            }
          } else {
            return this.handleStepChange(k)
          }
        }
        return (
          <div key={k} className="stepper-inner" onClick={handlerClickStepper}>
            <div
              className={`stepper-number ${
                activeStep === k ? 'active' : activeStep > k && 'success'
              }`}
            >
              <span>{k + 1}</span>
            </div>
            {k !== steps.length && (
              <div
                className={`stepper-label ${
                  activeStep === k ? 'active' : activeStep > k && 'success'
                }`}
              >
                {v.label}
              </div>
            )}
          </div>
        )
      }
      return map(steps, render)
    }
    const renderNextButton = () => {
      const handlerOnClick = () => {
        const isPassValidate = this.validateActiveStep()
        if (isPassValidate) {
          return this.nextStep()
        } else {
          return null
        }
      }

      if (activeStep === 0 || activeStep === 1 || activeStep === 2) {
        return (
          <Button
            disabled={this.isFileLoading()}
            onClick={() => handlerOnClick()}
            className="theme-blue"
          >
            Next
          </Button>
        )
      }
    }
    if (this.state.isLoading) {
      return (
        <Section className="loading">
          <Spinner />
        </Section>
      )
    } else {
      return (
        <React.Fragment>
          <Section className="form-wrapper">
            <Section className="form-group-title">{funcRenderStep()}</Section>
          </Section>
          <Section className="stepper">{funcRenderStepper()}</Section>
          {steps[activeStep].component}
          <Section className="form-actions">
            <Section className="button-group">
              <Button
                className="theme-border-gray"
                disabled={this.isFileLoading()}
                onClick={() => {
                  const { match } = this.props
                  const { params } = match
                  const { id, idproject, eventid } = params
                  if (idproject && eventid) {
                    const linkProjectDetails = `/sourcing-project-detail/${idproject}`
                    this.props.history.push(linkProjectDetails)
                  } else if (idproject && !eventid) {
                    const linkProjectDetails = `/sourcing-project-detail/${idproject}`
                    this.props.history.push(linkProjectDetails)
                  } else {
                    const linkProjectList = `/sourcing-projects`
                    // this.props.history.push(linkProjectList)
                    const linkProjectDetail = `/sourcing-project-detail/${params.id}`
                    localStorage.setItem('isFromDetail', false)
                    switch (this.state.isFromDetail) {
                      case 'true': {
                        return this.props.history.push(linkProjectDetail)
                      }
                      case 'false': {
                        return this.props.history.push(linkProjectList)
                      }
                      default: {
                        return this.props.history.push(
                          ROUTE_PATH.SOURCING_BUYER.LINK
                        )
                      }
                    }
                    // if (id) {
                    //   const linkProjectList = `/sourcing-projects`
                    //   this.props.history.push(linkProjectList)
                    // } else {
                    //   const linkProjectDetails = `/sourcing-projects`
                    //   this.props.history.push(linkProjectDetails)
                    // }
                  }
                }}
              >
                Cancel
              </Button>
              {(this.state.activeStep === 0 && this.state.getCreatenewround) ||
              !this.state.editRoleDetail ? (
                ''
              ) : (
                <Button
                  className="theme-blue remove"
                  disabled={this.isFileLoading()}
                  onClick={e => {
                    if (e.detail === 1) {
                      return this.onClickSaveDraft()
                    }
                  }}
                >
                  Save Draft
                </Button>
              )}
            </Section>

            <Section className="button-group">
              {activeStep !== 0 && (
                <Button
                  disabled={this.isFileLoading()}
                  className="theme-blue remove"
                  onClick={() => this.previousStep()}
                >
                  Back
                </Button>
              )}
              {renderNextButton()}
              {activeStep === 3 && this.state.editRoleDetail && (
                <Button
                  className="theme-green"
                  disabled={this.isFileLoading()}
                  onClick={() => {
                    if (this._isMounted) {
                      return this.setState(
                        { isSubmit: true },
                        this.isValidateSubmit
                      )
                    }
                  }}
                >
                  Submit
                </Button>
              )}
            </Section>
          </Section>
        </React.Fragment>
      )
    }
  }

  render() {
    const { modals, activeStep, clicks } = this.state
    const steps = [
      {
        label: 'SOURCING PROJECT',
        component: this.step1Content(),
      },
      {
        label: 'EVENT INFORMATION',
        component: this.step2Content(),
      },
      {
        label: 'EVENT ITEMS',
        component: this.step3Content(),
      },
      {
        label: 'EVENT SUMMARY',
        component: this.step4Content(),
      },
    ]

    return (
      <React.Fragment>
        <Loading loading={this.state.isLoader} spinner={this.state.isLoader} />
        <SourcingDetailBuyerFormStyled>
          {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_buyer_management"
                  src={ICONS['icon-sourcing-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_buyer_management" className="title">
                  Sourcing
                </Section>
                <Breadcrumbs props={this.props} />
              </Section>
            </Section>
          </Section>

          {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}

          <Section className="main-content create-event">
            <Section className="content-body">
              {this.renderCreateEventModal(activeStep, steps)}
            </Section>
          </Section>
        </SourcingDetailBuyerFormStyled>

        {/* Modal Add Supplier
          -----------------------------------------------------
          -----------------------------------------------------
          */}
        <Modal
          // id="sourcing-add-supplier"
          className="sourcing theme-blue add-supplier"
          // isOpen={isHistoryModalOpen}
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'add-supplier'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>Add Supplier</Modal.Header>

          <Modal.Body>
            <Section className="form-group">
              <Section className="form-group-control">
                <Section className="form-group-inner-wrapper">
                  <Input
                    id="search-supplier"
                    type="text"
                    name="search-supplier"
                    value={this.state.searchKeywords}
                    placeholder="Tax ID, Supplier Name, Supplier No."
                    onChange={this.onSearchSupplierRfqChange}
                  />
                  <Button
                    className="theme-blue"
                    onClick={this.onClickSearchSupplierRfq}
                  >
                    Search
                  </Button>
                </Section>

                <Section className="message"></Section>
              </Section>
            </Section>
            {/* <Section id="sourcing-add-supplier">
              <DivTable isScrollbar tableHeight="60vh">
                <DivTable.THEAD>
                  <DivTable.TR>
                    <DivTable.TH className="w-15p">TAX ID</DivTable.TH>
                    <DivTable.TH className="w-15p">SUPPLIER NAME</DivTable.TH>
                    <DivTable.TH className="w-15p">BRANCH</DivTable.TH>
                    <DivTable.TH className="w-15p">SUPPLIER NO. </DivTable.TH>
                    <DivTable.TH className="w-15p">CONTACT NAME</DivTable.TH>
                    <DivTable.TH>CONTACT EMAIL </DivTable.TH>
                  </DivTable.TR>
                </DivTable.THEAD>
                <DivTable.TBODY>
                  {this.stateSupplierRqfLoading ? (
                    <Spinner />
                  ) : (
                    this.renderSuppliersRqf(this.state.suppliersRfq)
                  )}
                </DivTable.TBODY>
              </DivTable>
            </Section> */}
            <Section
              className="popup-sourcing table-header-freeze-wrapper"
              id="sourcing-add-supplier"
            >
              <Table className="sourcing">
                <Table.THEAD>
                  <Table.TR>
                    <Table.TH className="tax-id">TAX ID</Table.TH>
                    <Table.TH className="company-name">SUPPLIER NAME</Table.TH>
                    <Table.TH className="branch-number">BRANCH</Table.TH>
                    <Table.TH className="vendor-code">SUPPLIER NO. </Table.TH>
                    <Table.TH className="contact-name">CONTACT NAME</Table.TH>
                    <Table.TH className="email">CONTACT EMAIL </Table.TH>
                  </Table.TR>
                </Table.THEAD>
                <Table.TBODY>
                  {this.stateSupplierRqfLoading ? (
                    <Spinner />
                  ) : (
                    this.renderSuppliersRqf(this.state.suppliersRfq)
                  )}
                </Table.TBODY>
              </Table>

              <Table className="sourcing split-row-color"></Table>
            </Section>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_add-supplier"
              className="theme-border-gray close"
              onClick={() => this.onClickCancelSelectSupplierRfq()}
            >
              Close
            </Button>
            <Button
              id="submit_modal_add-supplier"
              className="theme-green save"
              onClick={() => {
                this.onClickOKSupplierRfq()
              }}
            >
              Ok
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal Confirm Submit
          -----------------------------------------------------
          -----------------------------------------------------
          */}
        <Modal
          id="confirm-submit"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'confirm-submit'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Confirm</Modal.Header>

          <Modal.Body>
            <p className="default text-center">Are you sure to submit?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="theme-border-gray"
              onClick={() => {
                let { formData } = this.state
                const { step2 } = formData
                const { eventInformation } = step2
                formData.rfq_status_id = 1
                eventInformation.auction_status_id = 1
                this.toggleModal('confirm-submit'),
                  document.body.classList.remove('modal-open')
              }}
            >
              Cancel
            </Button>
            <Button className="theme-green" onClick={this.confirmOnClickModal}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal Switch event Alert Clear data Step 2-4  */}
        <Modal
          id="confirm-switch-event"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'confirm-switch-event'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Switch event type</Modal.Header>

          <Modal.Body>
            <p className="default text-center">
              Are you sure to switch event type? <br />
              <br />
              When switch event type Step 2 - 4 will clear data
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="theme-border-gray"
              onClick={() => {
                this.toggleModal('confirm-switch-event'),
                  document.body.classList.remove('modal-open')
              }}
            >
              Cancel
            </Button>
            <Button className="theme-green" onClick={this.switchEventClearData}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export const SourcingDetailBuyerFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(SourcingDetailBuyerForm))
